/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import {
  O_MAP,
  N_MAP,
  RP_SERVICE_DESCRIPTION_MAX_LENGTH,
  RP_ITEM_DESCRIPTION_MAX_LENGTH,
  STAGED_RP_MAX,
  M2_MODULES,
  M0,
  M1,
  M2,
  ACTIVE_HIGH,
  ACTIVE_LOW,
  VOLT_0_18K5,
  VOLT_0_6,
  RES_0_100k,
  RES_0_500,
  VOLT_0_16_rel,
  DTNA_CASE_MANAGEMENT_URL,
} from 'utils/constants.js'
import { getMapTypeRepresentation } from 'utils/mapDataMaps'
import { capitalizeFirstOnly } from 'utils/utils'
import { plural, connectorDisplayName } from 'utils/stringUtils'
import { toInt } from 'utils/types'

/* eslint-disable max-len */
export default {
  salesforce: 'Salesforce',
  refresh_complete: 'Refresh complete, no errors found',
  refresh_rps: 'Refresh RPs',
  routing_destinations: 'Routing Destinations',
  empty_string: '',
  zone: 'Zone',
  interval: 'Interval',
  calc_code: 'Calc Code',
  chec_help: 'CHEC Help',
  what_is_this: 'What is this?',
  no_associated_circuits: 'No associated circuits found',
  no_associated_bundles: 'No associated bundles found',
  no_associated_items: (resource) => `No associated ${resource} found`,
  no_circuit_variations: 'No variations of this circuit found',
  variations: 'Variations',
  amperage: 'Amperage',
  code_type: 'Code / Type',
  bundle: 'Bundle',
  affinities_label: 'Affinities:',
  bundle_description: 'Bundle Description',
  attribute: 'Attribute',
  copyright: (currentYear) =>
    `Copyright © ${currentYear} Daimler Truck North America LLC. All rights reserved.`,
  circuit_bundles_not_found: 'Circuit bundles not found.',
  circuit_details_not_found: 'Circuit details not found.',
  bundles_details_not_found: 'Bundle details not found.',
  circuit_revisions_not_found: 'Circuit notes not found.',
  bundle_revisions_not_found: 'Bundle notes not found.',
  collections_templates: 'Collections & Templates',
  feature_collections: 'Feature Collections',
  ctp_mapping: 'CTP Mapping',
  select_pin: 'Select Input Pin',
  editing_flag: '(editing)',
  source_pin: 'sourcePin',
  circuit_number_or_description: 'Enter a keyword or ID number',
  circuit_no: 'Circuit No.',
  bundle_no: 'Bundle No.',
  module_has_no_pins_on_connector:
    'This expansion module contains no pins on the selected connector',
  small: 'small',
  medium: 'medium',
  large: 'large',
  authorization: 'authorization',
  chec_authorization: 'CHEC Authorization',
  unauthorized_user_message: [
    'Thank you for your interest in the CHEC tool. If you recently completed the online training, please check back the following day to gain CHEC tool access.',
    'In order to gain accesss to the CHEC tool, you must complete the CHEC online training. Visit the ARC website for more information about CHEC Tool Training.',
  ],
  access_arc: 'Back to DTNA Access ARC ',
  true: 'True',
  false: 'False',
  when: 'when',
  is: 'is',
  update: 'Update',
  api_port: '9080',
  dtna_connect_url:
    'https://secure.freightliner.com/wps/myportal/dtnaconnect/DTNAConnectHome',
  enable: 'ENABLE',
  mlogic_enable_if: 'If',
  mlogic_enable_or: 'Or',
  if_met: 'If Met',
  not_met: 'Not Met',
  mlogic_enable_met: 'Met',
  mlogic_enable_not_met: 'Not Met',
  mlogic_control_met: 'Met',
  mlogic_control_not_met: 'Not Met',
  plc_slot: 'NPLC Slot',
  slot_number: 'Slot Number',
  more: 'More',
  less: 'Less',
  nplc_ign_block_label: 'PLC Block 1',
  nplc_enable_cell_1_label: 'PLC Block 2',
  nplc_enable_cell_2_label: 'PLC Block 3',
  nplc_enable_cell_3_label: 'PLC Block 4',
  nplc_output_label: 'PLC Block 5',
  sys_awake_label: 'Keep Awake',
  ign_bit_label: 'Run',
  acc_bit_label: 'ACC',
  crank_bit_label: 'Crank',
  off: 'Off',
  on: 'On',
  tripped: 'Tripped',
  row_id: 'Row ID',
  pin_location: (isInput) => `Pin ${isInput ? 'Input' : 'Output'} Location`,
  connector_location: (connector) =>
    // parse INT1, 23 -> Interior Connector 1, Pin 23
    connector,
  keep_awake: 'Keep Awake',
  keep_awake_tooltip: 'When enabled, this output will keep the vehicle awake',
  row_id_display: (val) => `Row ID: ${val}`,
  slot_name: 'Slot Name',
  ign_independent: 'Ignition Independent',
  ioname: 'I / O Name',
  output_name: 'Output name',
  control: 'CONTROL',
  logic: 'Logic',
  vehicle_comparison: 'Vehicle comparison',
  vehicle_compare_edit_mode: 'Vehicle comparison: Copy parameters',
  vehicle_comparison_subheader:
    'Copy parameters to additional vehicles by selecting open spaces in grid.',
  vehicle_comparison_confirmation:
    'Copy Reference Parameters to additional vehicles?',
  vehicle: 'Vehicle',
  vehicles: 'Vehicles',
  recently_viewed: 'Recently viewed',
  go_back: 'Go Back',
  go: 'Go',
  apply: 'Apply',
  copy: 'Copy',
  cancel: 'Cancel',
  confirm: 'Confirm',
  edit: 'Edit',
  duplicate: 'Duplicate',
  link: 'Link',
  unlink: 'Unlink',
  compare: 'Compare',
  compare_bhm_vehicles: 'Compare BHM Vehicles',
  compare_bhm_vehicles_title: 'BHM Vehicles',
  compare_vehicles: 'Compare Vehicles',
  only_show_differences: 'Only Show Differences',
  vehicle_compare_help:
    'Vehicle compare allows you to compare up to five BHM vehicles.',
  vehicle_compare_fleet:
    'Vehicle compare allows you to compare up to five vehicles within a BHM fleet.',
  move: 'Move',
  remove: 'Remove',
  revert: 'Revert',
  save_changes: 'Save Changes',
  save: 'Save',
  save_and_continue: 'Save & Continue',
  save_and_close: 'Save & Close',
  supporting_data_error: 'Supporting data fetch failed',
  save_note: 'Save Note',
  save_circuit_to_pin: 'Save Circuit to Pin',
  yes: 'Yes',
  yes_lower: 'yes',
  no: 'No',
  no_lower: 'no',
  view: 'view',
  pending: 'Pending',
  pending_pto_updates:
    'Updates to PTO will remain "Pending" until they have been programmed to DiagnosticLink. Click here for instructions.',
  pending_changes: 'Pending changes',
  pending_sng_updates:
    'Updates to Switch & Gauge will remain “Pending” until they have been programmed to DiagnosticLink. Click here for instructions.',
  pending_pneumatics_updates:
    'Pneumatics settings have been changed. Click here for instructions.',
  pending_updates_count: (count) => (
    <>
      <strong>Pending Updates ({count})</strong>
    </>
  ),
  setting_will_be_updated: ` Settings will be updated`,
  pin_is_in_as_built:
    'Cannot be removed because it already exists on the "As-Built" CTP record.',
  pin_is_in_omap:
    'Cannot be removed because the circuit is referenced by an O-MAP of the type "circuit", and this O-MAP is linked to a Reference Parameter on the vehicle.',
  sp_no_edit_if_not_pending:
    'Only Supporting Parameters that are pending verification can be edited.',
  activate: 'Activate',
  activate_supporting_parameter_confirmation:
    'Do you want to activate this parameter? This step cannot be undone.',
  activate_rp_confirmation: 'Activate Reference Parameter?',
  retry_activation: 'Retry Activation',
  activated_reference_parameter: 'Reference Parameter Activated',
  activated_support_parameter: 'Support Parameter Activated',
  activating_reference_parameter: 'Activating Reference Parameter',
  activating_sp_and_rp_activation_error:
    'Reference Parameter activation failed due to Support Parameter status error.',
  activating_support_parameter_activation_error:
    'Support Parameter Activation Error',
  database_error_rp_sp_activation:
    'Reference Parameter activation failed due to database error. Please try again.',
  activating_rp_requires_sp_activation:
    'Activating the RP requires activation of the following Support Parameters:',
  activating_rp_requires_error_state_sp_removal:
    'The following Support Parameters are not in a Pending status and cannot be activated. Remove or replace the following SPs to complete the Reference Parameter activation.',
  activate_parameters: 'Activate Parameters',
  activate_rp_warning:
    'Activating this parameter will lock it from further editing and can not be undone.',
  duplicate_rp_confirmation: (rp) =>
    `Duplicate Reference Parameter: ${rp.refParameterNumber}, Release: ${rp.release}?`,
  duplication_confirmation_body:
    'There is a more recent version of this parameter. Are you sure you want to duplicate this version?',
  pending_sp_linked_to_rp: (rp) =>
    `This Supporting Parameter is already linked to RP ${rp}. It must be unlinked from that parameter or activated before linking it to another Reference Parameter.`,
  linked_non_editable_rp_error: (rpNo) =>
    `Editing of this parameter is not allowed because it is linked to Reference Parameter ${rpNo}, which currently has a non-editable status.`,
  duplicate_sp_auth_fail: 'Not authorized to duplicate SP.',
  active: 'Active',
  pending_verification: 'Pending Verification',
  inactive: 'Inactive',
  not_active: 'Not Active',
  error: 'Error',
  in_error: 'IN Error',
  obsolete: 'Obsolete',
  version: 'Version',
  undo_delete: 'Undo delete',
  remove_vehicle: 'Remove Vehicle',
  return_to_search_results: 'Return to Search Results',
  return_to_vehicle_details: 'Return to Vehicle Details',
  parameter_copy_success: 'Parameters copied successfully',
  recently_viewed_logic: 'Recently Viewed Logic',
  your_recently_viewed_logic: 'Your Recently Viewed Logic',
  your_recently_viewed_vehicles: 'Your Recently Viewed Vehicles',
  deselect_all: 'Deselect All',
  supporting_parameter: 'Supporting Parameter',
  supporting_parameters: 'Supporting Parameters',
  reference_parameters: 'Reference Parameters',
  features: 'Features',
  features_created_by: 'Features Created By',
  features_serial: (serial) => `Features on ${serial}`,
  reference_parameters_serial: (serial) => `Reference Parameters on ${serial}`,
  default_feature_description: 'New Feature',
  reference_parameter: 'Reference Parameter',
  items: 'Items',
  location_title: 'Loc.',
  partnumber_title: 'Part No.',
  possible_part_inventory: 'Possible Part Information',
  desc_title: 'Description',
  bom_title: 'BOM',
  detail_title: 'Detail',
  description: 'Description',
  solenoid_name: 'Solenoid Name',
  pin_description: 'Pin Description',
  pin_name: 'Pin Name',
  pin_number: 'Pin Number',
  view_summary: 'View summary',
  invalidValueForSteps: 'invalid value for "steps"',
  an_error_has_occurred: 'An error has occurred',
  service_description_error: 'Service description cannot be blank',
  item_description_error: 'Item description cannot be blank',
  service_description_length_error: `Service description must be no more than ${RP_SERVICE_DESCRIPTION_MAX_LENGTH} characters`,
  item_description_length_error: `Item description must be no more than ${RP_ITEM_DESCRIPTION_MAX_LENGTH} characters`,
  service_item_description_error:
    'Service description and item description cannot be blank',
  circuit_duplication_error: 'This circuit is already in use on this RP.',
  rowid_duplication_error: 'This row id is already in use on this RP.',
  slot_duplication_error: 'This slot name is already in use on this RP.',
  invalid_support_parameter_in_rp:
    'Reference Parameter cannot be saved with invalid Support Parameters.',
  column_header_service_description: 'SERVICE DESCRIPTION',
  service_description: 'Service Description',
  support: 'Support',
  service_link: 'ServiceLink',
  item_description: 'Item Description',
  cannot_edit_active_rp: 'Active Reference Parameters may not be edited.',
  master_no: 'Master No.',
  release_no: 'Release No.',
  release_number: 'Release Number',
  m_logics_used: 'MLogic Used',
  colon_space: ': ',
  id_no: 'ID No.',
  id_pending: 'ID Pending',
  filter_status: 'Status:',
  status: 'Status',
  state: 'State',
  column_header_status: 'STATUS',
  search_tips: 'Search tips',
  vehicle_search_explainer:
    'Enter one or more serial numbers to look up vehicles.',
  submission_error: 'Please enter a search term',
  database_error_title: 'Database Error',
  database_error:
    'Could not complete activation due to a database error. Please retry the activation process again. If this error persists after the retry, contact CHEC support: ',
  search_no_results: 'Your search found no results.',
  search_again: 'Click here to search again.',
  available_reference_parameters: 'Available Reference Parameters',
  reference_parameters_on: 'Reference Parameters on',
  these_parameters_will_be_added: 'Adding the following RPs:',
  these_parameters_will_be_removed:
    'Replacing the following RPs with the same base numbers:',
  filter_by_id_or_keyword: 'Enter a keyword or ID number',
  more_filters: 'More Filters',
  fewer_filters: 'Fewer Filters',
  apply_filters: 'Apply Filters',
  use_fast_features: 'Apply Fast Features',
  filters: 'Filters',
  all: 'All',
  flags: 'Flags',
  no_min: 'No Min',
  no_max: 'No Max',
  min_must_be_less_than_max: 'Min ID must be less than Max ID',
  no_search_result_try_again: 'No results found. Please search again.',
  loading: 'Loading...',
  enter_search_term: 'Enter a search term',
  enter_vehicle_serial: 'Enter serial number',
  no_matching_slot_def: 'Could not find matching logical slot definition',
  logical_slot_title: 'Logical Slot',
  rp_title: 'RP',
  logical_operators_title: 'Logical Operators',
  omlogic_title: 'O-MLogic',
  oslotinit_title: 'O-SLOTINIT',
  omap_title: 'O-MAP',
  nmap_title: 'N-MAP',
  ofault_title: 'O-FAULT',
  nmlogic_title: 'N-MLogic',
  nmlogic2_title: 'N-MLogic 2',
  nappdtc_title: 'N-APP-DTC',
  nappfault_title: 'N-APP-Fault',
  nfuel_level_data_title: 'N-FUEL-LEVEL-DATA',
  nfuel_level_cfg_title: 'N-FUEL-LEVEL-CFG',
  ntemp_level_cfg_title: 'N-TEMP-LEVEL-CFG',
  nlightmonitor_title: 'N-LIGHTMONITOR',
  nplc_title: 'N-PLC',
  ntimer_title: 'N-Timer',
  otimer_title: 'O-Timer',
  timer_slot: 'Timer Slot',
  timer_slot_display: (reset, max, id) => `R${reset}-M${max}-${id}`,
  oslotcopy_title: 'O-Slot Copies',
  nslotcopy_title: 'N-Slot Copies',
  npreflight_title: 'N-PREFLIGHT',
  npreflight2_title: 'N-PREFLIGHT2',
  npreflight3_title: 'N-PREFLIGHT3',
  npriority_title: 'N-PRIORITY',
  nslotinit_title: 'N-SLOTINIT',
  ninitcopy_title: 'N-INITCOPY',
  nssaddress_title: 'N-SSADDRESS',
  nstalkswitch_title: 'N-STALKSWITCH',
  nsubdata_title: 'N-Subdata',
  ntemp_level_data_title: 'N-TEMP-LEVEL-DATA',
  misc_sps_title: 'Definitions',
  nuserdtc_title: 'N-User-DTC',
  nuserfault_title: 'N-User-Fault',
  maps_title: 'Maps',
  cans_title: 'CANs',
  timers_title: 'Timers',
  native: 'Native',
  overlay_title: 'Overlay',
  slot_copies_title: 'Slot Copies',
  smapslots_title: 'S-MAPSLOTS',
  smemory_title: 'S-MEMORY',
  scanslots_title: 'S-CANSLOTS',
  smlogicslots_title: 'S-MLOGICSLOTS',
  stimerslots_title: 'S-TIMERSLOTS',
  sslotinitslots_title: 'S-SLOTINITSLOTS',
  subconfigs_title: 'N-Subsystem Configs',
  npowerdown_title: 'N-POWERDOWN',
  nModal_title: 'N-Modal',
  nvin_title: 'N-VIN',
  ign_state: 'IGN STATE',
  nversion_title: 'N-VERSION',
  ncansize_title: 'N-CANSIZE',
  nrpsize_title: 'N-RPSIZE',
  nrploc_title: 'N-RPLOC',
  power_off_delay_time: 'Power Off Delay Time',
  batt_loss_delay: 'Battery Loss Delay',
  logic_loss_delay: 'Logic Loss Delay',
  check: 'check',
  chec_features: 'CHEC Features',
  chec_features_nav_title: 'Features & Access Levels',
  more_tools_nav_title: 'More Tools',
  chec_features_title: 'CHEC Features & User Access Levels',
  release_notes_title: 'Release Notes',
  neffortcontroldata_title: 'N-EFFORT-CONTROL-DATA',
  nanalogsensor8bitdata_title: 'N-ANALOG-SENSOR-8-BIT-DATA',
  nanalogsensor16bitdata_title: 'N-ANALOG-SENSOR-16-BIT-DATA',
  nanalogsensor32bitdata_title: 'N-ANALOG-SENSOR-32-BIT-DATA',
  neffortcontrolcfg_title: 'N-EFFORT-CONTROL-CFG',
  nanalogsensor8bitcfg_title: 'N-ANALOG-SENSOR-8-BIT-CFG',
  nanalogsensor16bitcfg_title: 'N-ANALOG-SENSOR-16-BIT-CFG',
  nanalogsensor32bitcfg_title: 'N-ANALOG-SENSOR-32-BIT-CFG',
  io_title: 'Input/Output',
  ok: 'OK',
  notes_title: 'Notes',
  on_date: (date) => ` on ${date}`,
  no_logic_viewed: (title) => `No ${title} have been viewed`,
  item_no: 'Item No.',
  search: 'Search',
  feature_search: 'Feature Search',
  search_vehicles: 'Search Vehicles',
  name_title: 'Name',
  id_title: 'ID',
  sp_id: 'SP ID',
  sp_no: 'SP No.',
  hr: 'hr',
  min: 'min',
  sec: 'sec',
  delay_hours: 'HH',
  delay_minutes: 'MM',
  delay_seconds: 'SS.S',
  formattedTime: (timeObj) =>
    `${timeObj.hours}:${timeObj.minutes}:${timeObj.seconds}`,
  time_elapsed: (elapsed) => {
    if (elapsed.time > 1) {
      return `${elapsed.time} ${elapsed.unit}s ago`
    }

    if (elapsed.time === 1) {
      return `${elapsed.time} ${elapsed.unit} ago`
    }

    return `< 1 ${elapsed.unit}`
  },
  timer_error_msg: (
    itemName = 'Timer',
    minValue = '0',
    maxValue = '1:49:13.5'
  ) => `${itemName} value must be between ${minValue} and ${maxValue}`,
  add_new_sp: 'Add Supporting Parameters',
  link_sp: 'Link Supporting Parameter',
  edit_compatibility: 'Edit Compatibility',
  you_have_not_viewed_any: 'You have not viewed any',
  compatilibility_updated:
    'Reference Parameter has been updated. Select "Save" to confirm changes.',
  select_module_compatibility: 'Select Module Compatibility',
  add_to_rp: 'Link to Reference Parameter',
  choose_an_sp_type: 'Choose a Supporting Parameter type',
  select_an_sp: 'Select a Supporting Parameter',
  sp_types: 'Supporting Parameter types',
  contact_us: 'Contact Us',
  send_comments: 'Please send your comments and questions to',
  update_can_id_to_change_io: 'Update CAN ID to change I/O',
  contact_email: 'checsupport@daimlertruck.com',
  look_forward_to_hearing: 'We look forward to hearing from you!',
  welcome_to_chec: 'Welcome to CHEC',
  chec_inflated: 'Custom Hardware Electronics Configurator',
  eula_disclaimer_title: 'CHEC Tool Disclaimer',
  eula_disclaimer: `Please refer to the General Information portion of the Freightliner / Western Star Cab and Chassis Vocational Reference Guide / Technical Resource Guide, which is applicable to any modifications or alterations made to the Bulkhead Module Specifications / Quickfit Extension Modules with the CHEC tool.
    
The CHEC tool is provided as a convenience for Truck Equipment Manufacturers (TEMs), Dealers, Direct Warranty Customers, and Customers Performing Warranty Agreements. CHEC provides the ability for technicians, developers, and engineers (Tier 1, Tier 2, and Tier 3 users, respectively; also referred to as “authorized users”) to verify, annotate, and / or change certain vehicle Bulkhead Module and Quickfit Extension Module specifications.

The CHEC tool is not intended to be used by anyone who does not have appropriate background and training, and some changes may require substantial expertise. Certain changes may affect vehicle performance and safety, and Daimler Truck North America does not assume any liability or damage to persons or property caused by changes made through the CHEC tool. Any modifications or alterations to the Bulkhead Module or Quickfit Extension Module (XMC) specifications made through the CHEC tool are the sole responsibility of the authorized user performing such work. The authorized user is also responsible for ensuring that the completed vehicle continues to comply with all applicable federal, state, and local safety, emission, and noise standards and agrees to hold Daimler Truck North America harmless for any violation thereof.
`,
  ease_of_upfit:
    'Ease of upfit can be accomplished with a great tool. Fast, trouble-free upfits improve your output, and your relationship with your customers.',
  at_dtna:
    'At Daimler Trucks North America, our software development teams are releasing updated software every three weeks, with new features and changes that have been requested by our customers.',
  participation_appreciated:
    'Your participation in beta testing CHEC is appreciated. Please send feedback correspondence to ',
  back_to_search: 'Back to Search',
  back_to_module: 'Back to Module',
  back_to_connector: 'Back to Connector',
  back_to_interface_connector: 'Back to Interface Connector',
  cic_ground_pin_source_tooltip: 'Vehicle electronics ground',
  view_pin_details: 'View Pin Details',
  update_not_available_pre_production:
    'Updates are not available for pre-production vehicles',
  upgrade: 'Upgrade',
  add_to_vehicle: 'Add to Vehicle',
  upgrade_exm: 'Upgrade EXM',
  exm_max: 'Reached the maximum EXM upgrade',
  exm_not: (type) => `${type} vehicles cannot accept EXM upgrades`,
  exm_add_warning: 'Warning: once the EXM is added it cannot be removed.',
  exm_upgrade_warning: 'Warning: Upgrading the EXM cannot be reversed.',
  insure_upgrade_installed: (size) =>
    `Ensure the new EXM (${capitalizeFirstOnly(size)}) is on the vehicle.`,
  exm_type: (size) => `EXM (${capitalizeFirstOnly(size)})`,
  select_size: 'Select Size',
  select_available_size: 'Select Available Size',
  add_exm: 'Add EXM',
  add_exm_to_vehicle: (serial) => `Add EXM to Vehicle ${serial}`,
  exm_upgrade_on_vehicle: (serial) => `Upgrade EXM on Vehicle ${serial}`,
  exm_added_on_vehicle: (moduleName) => `${moduleName} Added to CHEC`,
  exm_upgraded_on_vehicle: (moduleName, size) =>
    `${moduleName} Upgraded to ${capitalizeFirstOnly(size)}`,
  view_pins: 'View Pins',
  search_vehicles_results: 'Search Vehicles: Results',
  search_sp_hint_text: 'Enter a Supporting Parameter name or item number',
  search_rp: 'Search Reference Parameters',
  search_rp_results: 'Search Reference Parameters: Results',
  search_sp: 'Search Supporting Parameters',
  search_sp_results: 'Search Supporting Parameters: Results',
  search_features: 'Search features',
  search_features_header: 'Search Features',
  search_features_results: 'Search features: Results',
  search_status_required: 'Status required',
  module_type_required: 'Module type required',
  support_parameter_info_text: 'Choose a Supporting Parameter',
  dtna: 'DAIMLER TRUCKS NORTH AMERICA',
  chec_title: 'Custom Hardware & Electronics Configurator',
  make_vehicle_favorite: 'Add this vehicle to favorites list',
  make_source: 'Make Source',
  make_obsolete: 'Make Obsolete',
  vehicle_selected_as_source:
    'Vehicle selected as the source for a fleet update',
  remove_from_favorites: 'Remove from favorites',
  view_favorite_vehicles: 'View Favorite Vehicles',
  vehicle_snapshots: 'Vehicle Snapshots',
  favorite_vehicles: 'Favorite Vehicles',
  serial_number: 'Serial Number',
  serial_no: 'Serial No.',
  total_reference_parameters: 'Total Reference Parameters',
  bulkhead_module: 'Bulkhead Module',
  primary_module_version: 'Primary Module Version',
  bhm_version: 'BHM Version',
  primary: 'primary',
  secondary: 'secondary',
  bhm: 'BHM',
  bhm_l: 'BHM_L',
  rvm_a: 'RVM_A',
  rvm: 'RVM',
  smartplex_module: 'SmartPlex Module',
  smartplex_connector: 'SmartPlex Connector',
  module_type: 'Module Type',
  input_output_type: (type) => `${capitalizeFirstOnly(type)} Type`,
  smp: 'SMP',
  shm: 'SHM',
  chassis_module: 'Chassis Module',
  image_currently_unavailable: 'Image currently unavailable',
  chm: 'CHM',
  build_date: 'Build Date',
  add_parameters: `Add Parameters`,
  add_parameters_to_vehicle: (serial) =>
    `You are about to commit changes to vehicle ${serial}`,
  reference_parameter_schematic: 'Reference Parameter: Schematic',
  support_parameter_schematic: 'Supporting Parameter: Schematic',
  back_to_reference_parameter_search: 'Back to Reference Parameter Search',
  back_to_reference_parameter: 'Back to Reference Parameter',
  back_to_support_parameter_search: 'Back to Supporting Parameter Search',
  editing_reference_param: 'You are editing this Reference Parameter',
  editing_param: 'You are editing this parameter',
  // editing_param_type_error: type => `${type} with conflicting ${type === 'Map(s)' ? 'Circuit Name' : 'Row ID'} must be addressed before saving this RP.`,
  editing_param_type_error: (type) =>
    `${type} with conflicting properties must be addressed before saving this RP.`,
  logical_slot_and_row_id_conflict: `in this MAP has a conflict with a Logical Slot or Row ID in another MAP`,
  editing_feature: 'You are editing this Feature',
  are_you_sure_you_want_to_convert_this_feature:
    'Are you sure you want to revise the Feature?',
  when_the_next_version_of_this_feature:
    'When the next version of this Feature becomes “Active,” this version will become “Obsolete.”',
  editing_pto_template: 'You are editing this PTO Template',
  editing_feature_collection_note:
    'Note: You are editing this Feature Collection',
  view_details: 'View Details',
  vehicle_details: 'Vehicle details: ',
  vehicle_summary: 'Vehicle Summary',
  add_reference_parameter: 'Add Reference Parameters to vehicle',
  compatible_reference_parameters: 'Compatible Reference Parameters',
  search_compatible_reference_parameters:
    'Search Compatible Reference Parameters',
  vehicle_updated: 'Vehicle successfully updated',
  switch_validation_failed:
    'Unable to verify switches already on vehicle. Please try again.',
  feature_updated_swga: 'Feature update to Switch & Gauge complete',
  feature_updated_ecu: 'Feature update to ECU complete',
  feature_unsaved_changes:
    'You are about to abandon your progress. Are you sure you want to stop editing this Feature?',
  back_to_vehicle: (vehicleId) => `Back to Vehicle ${vehicleId}`,
  back_to_vehicle_details: 'Back to vehicle details',
  back_to_supporting_parameter: (spId) =>
    `Back to Supporting Parameter ${spId}`,
  bacl_to_rp: (rpId) => `Back to Reference Parameter ${rpId}`,
  vehicles_selected_msg: (count) =>
    `${count} vehicle${plural(count)} selected for comparison.`,
  remove_serial_from_list_of_favorites: (serial) =>
    `Remove ${serial} from list of favorite vehicles?`,
  reference_parameter_status: (status) => `\u00A0 | Status: ${status}`,
  // RP & SP Lifecycle Status Display (PBI 133848 - C+ alignment)
  rp_status_design_new: 'Design (New)',
  rp_status_design_returned: 'Design (Returned)',
  rp_status_design: 'Design',
  rp_status_test: 'Test',
  rp_status_active: 'Active',
  rp_status_obsolete: 'Obsolete',
  sp_status_design: 'Design',
  sp_status_active: 'Active',
  sp_status_obsolete: 'Obsolete',
  lifecycle_phase_design: 'Design',
  lifecycle_phase_test: 'Test',
  lifecycle_phase_active: 'Active',
  lifecycle_phase_obsolete: 'Obsolete',
  support_parameter_display: (sp) =>
    sp.id !== null
      ? `${sp.supportParameterType}:  ${
          sp.supportParameterType === O_MAP || sp.supportParameterType === N_MAP
            ? getMapTypeRepresentation(sp.type)
            : ''
        }  SP ${sp.id} | `
      : `${sp.supportParameterType}   SP Pending ID | `,
  io_format_body_input: ({ connectorname, pin, state }) =>
    `${connectorname} PIN ${pin} ${state ? `= ${state}` : ''}`,
  io_format_signal_input: ({ name, state }) =>
    `${name} ${state ? `= ${state}` : ''}`,
  io_format_ss_input: ({ name, state }) =>
    `${name} ${state ? `= ${state}` : ''}`,
  io_format_message: ({ name, state }) =>
    `${name}${state ? ` = ${state}` : ''}`,
  io_format_body_output: ({ connectorname, pin, name, state }) =>
    `${connectorname || ''}(${pin}) -- ${name} ${state ? `= ${state}` : ''}`,
  io_format_indicator_output: ({ name, state }) =>
    `${name} ${state ? `= ${state}` : ''}`,
  io_format_signal_output: ({ state, name }) => `${state || ''} ${name}`,
  mlogic_editor_prompt:
    'Select a logical slot or output, or drag an item from the input/output list to the schematic',
  mlogic_slot: 'MLogic Slot',
  logout: 'Sign Out',
  logout_warning_title: 'Log out?',
  last_viewed: 'Last Viewed',
  recently_viewed_vehicles: 'Recently viewed vehicles',
  recently_viewed_sps: 'Recently viewed SPs',
  recently_viewed_rps: 'Recently viewed RPs',
  recently_viewed_features: 'Recently viewed Features',
  logout_warning_msg: 'Any unsaved changes will be lost.',
  open: 'Open',
  short: 'Closed',
  input: 'Input',
  input_pin: 'Input Pin',
  boolean_inputs: 'Native Input (boolean)',
  non_boolean_inputs: 'Native Input (non-boolean)',
  value: 'Value',
  choose_an_input: 'Choose an input...',
  choose_an_output: 'Choose an output...',
  outputs: 'Outputs',
  output: 'Output',
  enable_not_met: 'Enable = Not Met',
  control_met: 'Control = Met',
  control_not_met: 'Control = Not Met',
  needs_verification: 'Needs Verification',
  duplicate_rp_uri: (rpId, release) =>
    `/reference-parameters/duplicate/${rpId}/${release}`,
  ecus: 'ECUs',
  pneumatics: 'Pneumatics',
  vehicle_ctp_uri: (serialNumber) => `/ctp/${serialNumber}`,
  vehicle_ctp_report_uri: (serialNumber) => `/ctp/report/${serialNumber}`,
  circuits_by_rp_uri: (rpId, release) => `/ctp/${rpId}/${release}`,
  circuits_by_rp_uri_v2: (rpId, release) =>
    `/reference-parameters/${rpId}/${release}/circuits`,
  move_circuit_button: 'Move Circuit',
  move_circuit: 'Move circuit',
  from: 'from',
  to: 'to',
  available_pin: 'available pin',
  moving_circuit_header: (pinStatus) => `Moving ${pinStatus} circuit`,
  move_circuit_to_pin: (circuit, pinStatus) =>
    `Moving ${pinStatus} circuit ${circuit}`,
  verify_your_wiring_compatibility: `Verify that your wiring is
      compatible with this move.`,
  move_circuit_complete: (circuit) => `${circuit} Move Complete`,
  moving_circuit_number: (circuit) => `Moving Circuit ${circuit}`,
  move_circuit_failed: 'Move Circuit Failed',
  how_did_you_get_here: 'How did you get here?',
  remove_circuit: 'Remove Circuit',
  remove_circuit_failed: 'Remove Circuit Failed',
  remove_circuit_from_vehicle: (circuit, pinStatus, vehicle) =>
    `Remove ${pinStatus} ${circuit} from ${vehicle}`,
  removal_complete: (circuit) => `${circuit} Removal Complete`,
  removing_circuit_warning:
    'Removing this circuit will remove any associated parameters from this vehicle.',
  circuit: 'Circuit',
  circuit_description: 'Circuit Description',
  next: 'Next',
  back: 'Back',
  step_x_of_y: (step, stepCount) => `Step ${step} of ${stepCount}`,
  select_ctp_pin: 'Select Input Pin',
  select_output: 'Select Output',
  select_pin_to_view: 'Select a pin to view details.',
  select_rp: 'Select Reference Parameter',
  select_circuit: (connector, pin) => `Select Circuit for ${connector}_${pin}`,
  closed: 'Closed',
  close: 'Close',
  edit_module: (module, connector) => {
    if (module === M2_MODULES.BHM) {
      return `Edit Bulkhead Module, Connector ${connector}`
    }

    if (module === M2_MODULES.CHM) {
      return `Edit Chassis Module, Connector ${connector}`
    }

    return `Edit Connector ${connector}`
  },
  select_connector: 'Select Connector',
  select_connector_view_details: 'Select connector to view details',
  select_connector_to_view_diagram:
    'Select connector to view diagram from wire insertion end.',
  module_updated: 'The module has been updated',
  activation_notification: (slotName) => `${slotName} has been activated`,
  no_circuit_for_pin: (location) => `No circuit for pin ${location}`,
  rps_in_use: 'In use by these Reference Parameters:',
  ctp_report: 'CTP Report',
  select_a_connector: 'Select a connector from the list to view its location',
  fleet: 'Fleet',
  show_fleet: 'Show Fleet',
  fleet_summary: 'Fleet Summary',
  fleet_view: (fleet) => `Fleet View: ${fleet}`,
  fleet_management: 'Manage Fleet',
  lead_vin: 'Lead VIN',
  vin: 'VIN',
  update_all_vehicles_in_fleet: 'Update all vehicles in fleet',
  changes_will_update_fleet:
    'Your changes will update all vehicles in the fleet',
  show_the_report_for: 'Show the report for: ',
  as_serviced: 'As-Serviced',
  as_built: 'As-Built',
  as_built_badge_factory: 'Factory',
  as_built_badge_service: 'Service',
  as_built_lead_vin_ref: (isLeadVin, leadVin, fleetSize) =>
    isLeadVin || fleetSize === 0 ? 'As-Built' : `As-Built (${leadVin})`,
  no_service_record: 'This vehicle does not have a service record.',
  as_built_below: 'The "As-built" report is below.',
  as_built_for: 'The "As-built" report for ',
  is_below: ' is below.',
  circuit_type_as_built: '(As-Built Circuit)',
  circuit_as_built: 'Circuit - As-Built ',
  timer_ends: 'Initial timer ends at',
  repeat_cycle: 'Repeat cycle?',
  seconds: 'Seconds',
  milliseconds: 'Milliseconds',
  milliseconds_lowercase: 'milliseconds',
  start_repeat_cycles_at: 'Start repeat cycles at',
  search_error:
    'There was a problem communicating with the server.  Please try your search again.',
  server_error: 'The server reported an error:',
  try_again: 'Please try again',
  signal_type: 'Signal Type',
  pgn: 'PGN',
  rx_tx: 'RX/TX',
  unique_id: 'Unique ID',
  byte_offset: 'Byte Offset',
  address: 'Address',
  destination_address: 'Destination Address',
  destination: 'destination',
  destination_uppercase: 'DESTINATION',
  source_address: 'Source Address',
  source: 'source',
  source_uppercase: 'SOURCE',
  source_cap: 'Source',
  message_id: 'Message ID',
  update_rate: 'Update Rate',
  sending: 'Sending',
  receiving: 'Receiving',
  select: 'Select',
  select_a_part: 'Select a part',
  select_a_pgn: 'Select a PGN',
  select_an_address: 'Select an Address',
  global_alerts_title: 'Global Alerts',
  zone_alerts_title: 'Zone-specific Alerts',
  global_alert_label: 'Global Alert Message',
  rp_alert_label: 'Reference Parameter Specific Alert Message',
  features_alert_label: 'Features Specific Alert Message',
  pto_alert_label: 'PTO Specific Alert Message',
  sng_alert_label: 'Switch and Gauge Specific Alert Message',
  bhm_ecu_alert_label: 'BHM: ECU Specific Alert Message',
  ceea_plus_ecu_alert_label: 'CEEA+: ECU Specific Alert Message',
  pneumatic_alert_label: 'Pneumatic Specific Alert Message',
  manage_alerts: 'Manage Alerts',
  alert_placeholder: 'Enter Message',
  reference_parameter_ptp_error: 'Reference Parameter PTP Error',
  ptp_error_report: 'Parameter Translation Process(PTP) error report:',
  ptp_alert: 'Alert from Parameter Transformation Process',
  rp_stage_max: `You may only add ${STAGED_RP_MAX} parameters at a time.`,
  duplicate_rp_add: (value) =>
    `A Reference Parameter with the same base number ${value} is already being added.  Unstage it (close Search dialog, click red X) to add this one.`,
  rp_requires_circuit_mapping: (rpId, serialNumber) =>
    `RP ${rpId} requires circuit mapping to Vehicle ${serialNumber}`,
  compatible_modules: 'Compatible Modules',
  compat_id: 'Compat ID',
  module: 'Module',
  search_results_for: (searchTerm) =>
    // remove both double and single quotes
    `Search results for "${searchTerm.replace(/['"]+/g, '')}"`,
  can_slot: 'CAN Slot',

  numeric_only: 'Value must be numeric',
  chars_remaining: (num) => `${num} characters remaining`,
  value_exceeds_character_limit: 'Value entered exceeds character limit.',
  value_violates_regex: 'Value entered is not in the correct format.',
  disallowed_chars: (charArray) =>
    `${charArray.map((char) => `"${char}"`).join(', ')} are not allowed.`,
  numeric_range_error: (name = 'Value', min, max) =>
    `${name} must be in range ${min}-${max}`,
  numeric_include_error: (name = 'Value', values = []) =>
    `${name} must be in range [${values.join(', ')}]`,
  duplicate_multiple_values: (values) =>
    `You cannot save this Support Parameter because a Support Parameter with the same ${values} is already used within this Reference Parameter.`,
  duplicate_value: (value) =>
    `You cannot save this Supporting Parameter because its ${value} is already used within this Reference Parameter.`,
  cannot_link_duplicate_value: (value) =>
    `You cannot link this Supporting Parameter because its ${value} is already used within this Reference Parameter.`,
  can_not_add_sp: (spType) =>
    `You cannot link this ${spType} to this Reference Parameter. It has an identical Row ID or Slot Name as another ${spType} currently linked to the Reference Parameter.`,
  save_or_cancel_edit_sp:
    'You must save or cancel the duplicated Supporting Parameter before saving this Reference Parameter',
  save_or_cancel_edit_rp:
    'To update the status you must save or cancel your changes.',
  ref_param_duplicated: 'Reference Parameter duplicated',
  ref_param_dup_error_incomplete_info:
    'Reference Parameter information missing',
  ref_param_dup_error_status:
    'Reference Parameter must be in active or obsolete status',
  ref_param_dup_error_forbidden:
    'Duplication of Reference Parameter is forbidden.',
  results: 'results',
  of: 'of',
  no_search_results: "We couldn't find any results for ",
  no_search_results_x: (x) => `We couldn't find any results for ${x}`,
  view_sp: 'View SP',
  enter_number_between_0_and_65535: (unitName) =>
    `Please enter a number between 0 and 65535${` ${unitName}`}.`,
  invalid_message_id: (messageId) =>
    `Invalid Message ID '${messageId}'. Valid Message IDs are in the range 0-255.`,
  invalid_timer_value: (value) => `Invalid timer value '${value}'.`,
  invalid_reset_value: (value) => `Invalid reset value '${value}'.`,
  select_valid_io_name:
    'Please select a valid IO Name when in Input mode for a block',
  unable_to_validate_sptype: (spType) =>
    `Unable to validate Support Parameter type: ${spType}`,
  support_parameter_updated: 'Support Parameter updated',
  support_parameter_save_failed: 'Failed to save Support Parameter',
  reference_parameter_save_failed: 'Failed to save Reference Parameter',
  reference_parameter_status_update_failed:
    'Failed to update Reference Parameter status',
  exm1: 'EXM1',
  exm2: 'EXM2',
  exm3: 'EXM3',
  dash_o: 'DASH_O',
  recreational_vehicle_module: 'Recreational Vehicle Module',
  test: 'Test',
  returned: 'Returned',
  return: 'Return',
  verified: 'Verified',
  verify: 'Verify',
  design: 'Design',
  to_test: 'Move to Test',
  new: 'New',
  edit_notes: 'Add a Note',
  activate_or_unlink:
    'To activate this Reference Parameter you must first activate or unlink the following Supporting Parameters.',
  can_not_activate_rp: 'Can not activate Reference Parameter',
  update_status_to_add: 'Update status to add parameter to vehicle',
  status_update_required: 'Status update required',
  truck_compare_alert:
    "Adding Reference Parameters to vehicles via the Vehicle Comparison page has been disabled. Users should add Reference Parameters via each vehicle's details page.",
  add_to_all_vehicles: 'Add parameters to all vehicles in this fleet',
  commit_parameters: (bool) =>
    `Commit parameters to ${bool ? 'fleet' : 'vehicle'}`,
  used_in_param: 'Used in this parameter',
  all_other_io: 'All other I/Os',
  type: 'type',
  type_cap: 'Type',
  omap_type: 'O-Map type',
  nmap_type: 'N-Map type',
  vehicle_service_record: 'Vehicle Service Record',
  vehicle_service_record_modal:
    "Updating this vehicle's settings will create a Service Record and affect your warranty.",
  vehicle_service_record_modal_pt2:
    'For more information please contact your dealer.',
  i_want_to_continue: 'I Want to Continue',
  no_ctp_modules: 'Error: No ECU information for this vehicle',
  display_logical_slot: (value, string) => `${value} ${string}`,
  display_switch_id: (value, string) => `${value} ${string}`,
  sp_warning: (type) =>
    `The usage of this ${type} may vary from one Reference Parameter to another.`,
  select_num: 'Select No.',
  name_slot: 'Name Slot',
  name_this_slot: 'Name this slot...',
  add: 'Add',
  id: 'ID',
  minute: 'minute',
  hour: 'hour',
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
  no_favorite_vehicles:
    "You don't have any favorite vehicles. You can add a vehicle to this list from the vehicle summary page.",
  no_available_target_pins:
    'There are no valid target pins to move this circuit.',
  pins: 'Pins',
  pin: 'Pin',
  service: 'Service',
  internal: 'Internal',
  can: 'CAN',
  connector: 'Connector',
  ecu: 'ECU',
  current_rating: 'Current Rating',
  current_limit_title: 'Current (A)',
  map_circuit_to_pin: (circuit) =>
    `Map ${circuit.circuitNumber} - ${circuit.description} to an available ${
      circuit.priority === '65535' ? 'input' : 'output'
    }`,
  pin_assignment: 'Assign Pin',
  map_circuits_to_pins: 'Map Circuits to Pins',
  param_cannot_be_added_to_vehicle: (param, serialNumber) =>
    `RP ${param} cannot be added to Vehicle ${serialNumber}`,
  param_cannot_be_mapped: 'There are no available pins for this parameter',
  param_cannot_be_mapped_param: (param) =>
    `Parameter ${param.refParameterNumber}: ${param.serviceDescription}`,
  param_cannot_be_mapped_message: (pluralCircuits) =>
    `requires the following ${pluralCircuits ? 'circuits' : 'circuit'}:`,
  param_cannot_be_mapped_configurable:
    'The following parameters are still reconfigurable:',
  param_cannot_be_mapped_assistance:
    'For further assistance, contact customer support at:',
  param_cannot_be_mapped_phone: '855-855-8555',
  back_to_release: (release) => `Back to release ${release}`,
  timer_will_not_repeat: (interval) =>
    `This timer will not repeat after the initial cycle. After the initial cycle, this timer will hold a value of ${interval}`,
  /* eslint-disable no-nested-ternary */
  timer_will_repeat: (hr, min, sec) =>
    `Repeat cycles for this timer will have a${hr > 0 ? ` ${hr} hour` : ''}${
      hr > 0 && min > 0 && sec > 0
        ? `,`
        : hr > 0 &&
          ((min > 0 && parseFloat(sec) === 0) || (min === 0 && sec > 0))
        ? ` and`
        : ''
    }${min > 0 ? ` ${min} minute` : ''} ${
      (hr > 0 || min > 0) && sec > 0
        ? `and ${sec} second`
        : sec > 0
        ? `${sec} second`
        : ''
    } duration.`,
  hours_minutes_seconds: (hr, min, sec) =>
    `${hr > 0 ? ` ${hr} hour${hr > 1 ? `s` : ''}` : ''} ${
      hr > 0 && min > 0 && sec > 0
        ? `,`
        : hr > 0 && min > 0 && parseFloat(sec) === 0
        ? ` and`
        : ''
    }${min > 0 ? ` ${min} minute${min > 1 ? `s` : ''}` : ''} ${
      (hr > 0 || min > 0) && sec > 0
        ? `and ${sec} second${sec > 1 ? `s` : ''}`
        : sec > 0
        ? `${sec} second${parseFloat(sec) !== 1 ? `s` : ''}`
        : hr === 0 && min === 0 && parseFloat(sec) === 0
        ? `0 seconds`
        : ''
    }`,
  /* eslint-enable no-nested-ternary */
  switchandgauge: 'Switch & Gauge',
  sngPanel: 'Panel',
  sngICU: 'ICU',
  sngLS: 'LS',
  sngRG: 'RG',
  sngAG: 'AG',
  sngMain: 'main',
  sngWing: 'ICU',

  available: 'Available',
  notes: 'Notes',
  view_notes: 'View Notes',
  see_all: (num) => `See all (${num})`,
  only_show_latest: 'Only show latest',
  type_your_note: 'Add a note',
  prod: 'Prod',
  qa: 'QA',
  dev: 'Dev',
  stg: 'Stg',
  sandbox: 'Sandbox',
  local: 'Local',
  uat: 'UAT',
  parameter_status_updated: 'Parameter status has been updated',
  support_param_saved: 'Support Parameter Saved',
  support_param_save_failed: 'Failed to save Support Parameter.',
  notes_required: 'Add a note (required)',
  notes_required_star: 'Notes*',
  fleet_update_required_star: 'Fleet Update*',
  allium_save_warning:
    'Warning: Saving Allium data may cause some component placements to update automatically',
  vehicle_history_title: (serialNumber) => `Vehicle History: ${serialNumber}`,
  vehicle_history: 'Vehicle History',
  no_vehicle_history: 'This vehicle has no service history.',
  user: 'User',
  date: 'Date',
  type_title: 'Type',
  pin_type: 'Pin Type',
  input_type: 'Input Type',
  event_type: 'Event Type',
  parameters_edited: (paramCount) => `Parameter edit (${paramCount})`,
  ctp_edit: 'CTP Edit',
  unknown: 'Unknown',
  logics_available_title: 'MLogics Available',
  timers_available_title: 'Timers Available',
  logics_available_output: (total) => `(max ${total})`,
  timers_available_output: (total) => `(max ${total})`,
  mlogic: 'MLogic',
  single_run_timer: 'Single run',
  repeating_timer: 'Repeating',
  enabled: 'Enabled',
  disabled: 'Disabled',
  system_requirements: 'System Requirements',
  minimum_requirements: 'Minimum requirements',
  hardware: 'Hardware',
  browser: 'Browser',
  connectivity: 'Connectivity',
  max_allowed_timers_restriction: 'Exceeds max timers',
  max_allowed_logics_restriction: 'Exceeds max MLogics',
  max_allowed_resources: 'Exceeds max MLogics & timers',
  already_staged: 'Already staged on vehicle',
  pin_table_pin_title: (location) => `Pin ${location}`,
  // undefined module here may be sign of a deeper issue...
  pin_table_connector_title: (moduleName, connectorName) =>
    `${moduleName} Connector ${
      moduleName ? connectorDisplayName(moduleName, connectorName) : ''
    }`,
  pin_table_interface_connector_title: (
    interfaceConnector,
    connectorLocation
  ) => `${interfaceConnector} ${connectorLocation}`,
  interface_pin_table_title: (type, conNum) => `${type} Connector ${conNum}`,
  EXT: 'Exterior',
  INT: 'Interior',
  no_valid_target_pins: '(No available pins of appropriate type.)',
  pin_type_fixed: '(Pin type not editable.)',
  active_high: 'Active High',
  active_high_polarity: 'Active High Polarity',
  active_low: 'Active Low',
  active_low_polarity: 'Active Low Polarity',
  volt_0_18k5: 'Voltage 0.0 - 18.5V',
  volt_0_6: 'Voltage 0.0 - 6V',
  res_0_100k: 'Resistance 0 - 100kΩ',
  res_0_500: 'Resistance 0 - 500Ω',
  volt_0_16_rel: 'Relative Voltage 0 - 500%',
  not_configured: 'Not configured',
  configurable_input_change_warn_header_text: (pinName) =>
    `Update all ${pinName} attributes?`,
  configurable_input_confirm_button_text: 'Update All Instances',
  configurable_input_change_warn: (pinName) =>
    `Changing the attributes of ${pinName} will change the attributes of every instance of ${pinName} in this Feature.`,
  hysteresis: 'Hysteresis',
  edge_trigger: 'Edge Trigger',
  hysteresis_units: (units = null) =>
    units === null ? `Hysteresis` : `Hysteresis (${units})`,
  input_value: 'Value',
  timer_mode_label: 'Timer Mode',
  activate_query_label: 'Activate Condition',
  reset_query_label: 'Reset Condition',
  activate_label: 'Activate',
  reset_label: 'Reset',
  reset_cycles: 'Reset Cycles',
  timer_initial_value_label: 'Initial Value',
  timer_initial_value_hint: 'h.mm.ss',
  carry_timer_initial_value_hint: 'h.mm.ss.s',
  timer_format_hint: 'hh:mm:ss.s',
  query_1_label: 'Condition 1',
  query_2_label: 'Condition 2',
  query_3_label: 'Condition 3',
  query_4_label: 'Condition 4',
  condition_label: (index) => `Condition ${index}`,
  bundle_or_master_number: 'Enter a bundle number or master number',
  no_notes: '0 Notes',
  circuits: 'Circuits',
  attributes: 'Attributes',
  bundles: 'Bundles',
  logic_set_description: 'Logic Set Description',
  logic_sets_used: 'Logic Sets Used',
  timers_used: 'Timers',
  logic_sets: 'Logic Sets',
  indicators: 'Indicators',
  can_inputs: 'CAN Inputs',
  can_inputs_used: 'CAN Inputs Used',
  switch_indicators_used: 'Switch Indicators Used',
  max: 'Max ',
  preview_feature_non_edit: 'Preview Feature (Not Editable)',
  new_tab: 'Open in a new tab',
  missing_required_value: (fieldName) => `Specify a ${fieldName}`,
  feature_description: 'Feature Description',
  select_feature: 'Select Feature',
  must_edit_param_before_saving: 'You must edit this parameter before saving.',
  output_description: 'Description',
  output_type: 'Output Type',
  input_data_source: 'Controlling Output With',
  output_condition_complex: 'Logic Set or Timer',
  output_condition_single: 'Single Condition',
  output_type_PIN: 'Output Pin',
  output_type_floating_circuit: 'Floating Circuit',
  output_type_SERVICE: 'Native Output',
  output_type_CAN: (num) => `CAN ${num} Bit`,
  polarity: 'Polarity',
  high_side: 'High Side',
  high_side_driver: 'High Side Driver',
  low_side: 'Low Side',
  low_side_driver: 'Low Side Driver',
  pwm: 'PWM',
  output_pin: 'Output Pin',
  current_a: 'Current (A)',
  current: 'Current',
  enter_master_number: 'Enter Master No.',
  enter_release_number: 'Enter Release No.',
  duty_cycle: 'Duty Cycle',
  duty_cycle_min: 'Duty Cycle Min',
  duty_cycle_max: 'Duty Cycle Max',
  duty_cycle_hint: '10-50%',
  duty_cycle_label_append_symbol: '%',
  frequency: 'Frequency',
  frequency_min: 'Frequency Min',
  frequency_max: 'Frequency Max',
  frequency_hint: '20-150Hz',
  frequency_label_append_symbol: 'Hz',
  virtual_load: 'Virtual Load',
  no_auth: (permission, action) =>
    `Sorry, you must have ${permission} authorization to ${action}.`,
  view_page_action: 'view this information',
  is_internal_engineer: 'internal engineer or administrator',
  is_internal_admin: 'internal administrator',
  checplus: 'CHEC+',
  is_checplus: 'CHEC+ user',
  output_pin_name: 'Output Pin Name',
  view_full_diagram: 'view full diagram',
  view_simplified_diagram: 'view simplified diagram',
  import_supporting_parameter: 'Import Supporting Parameter',
  batch_import_supporting_parameter: 'Batch Import from Reference Parameter',
  import_supporting_parameters: 'Import Supporting Parameters',
  select_rp_short: 'Select RP',
  select_sps_short: 'Select SPs',
  review: 'Review',
  select_supporting_params_and_status:
    'Select Supporting Parameters and Status',
  uneditable: 'Uneditable',
  editable: 'Editable',
  sp_link_instructions: (rpNum) =>
    `This Supporting Parameter is already linked to RP ${rpNum}. It must be unlinked from that parameter or activated before linking it to another Reference Parameter.`,
  from_reference_parameter: 'From Reference Parameter',
  selected_supporting_parameters: 'Selected Supporting Parameters',
  remove_vehicle_from_favorite_list: 'Remove vehicle from favorite list',
  accept: 'Accept',
  sign_out: 'Sign Out',
  parameter_has_unmapped_circuits: (num) =>
    `This parameter has ${num} unmapped circuits`,
  support_parameters: 'Support Parameters',
  date_time: 'Date / Time',
  common_node_pins_title: 'Common Node Pins',
  batch_import_success_toast: 'Support Parameters Added',
  support_parameter_added:
    'Support Parameter added to current Reference Parameter',
  unavailable: 'Unavailable',
  no_input_available: '- Unavailable -',
  support_parameter_added_to_reference_parameter:
    'New Support Parameter Created',
  sp_already_exists_on_target_rp: (rpNum) =>
    `Cannot be selected because it already exists on RP ${rpNum || ''}`,
  reference_parameter_saved: 'Reference Parameter Saved',
  reference_parameter_notes_saved: 'Reference Parameter Notes Saved',
  selection_required: 'Selection required',
  no_edge: 'No Edge',
  both_edges: 'Both Edges',
  falling_edge: 'Falling Edge',
  rising_edge: 'Rising Edge',
  edge_detection: 'Edge Trigger',
  asam: 'ASAM',
  xmc1: 'XMC 1',
  xmc2: 'XMC 2',
  xmc3: 'XMC 3',
  xmc4: 'XMC 4',
  xmc5: 'XMC 5',
  xmc6: 'XMC 6',
  xmc7: 'XMC 7',
  xmc8: 'XMC 8',
  xmc: 'XMC',
  following_circuits_need_to_be_mapped:
    'The following circuits need to be mapped to pins before adding this parameter to a vehicle.',
  download_par_file: 'Download .PAR File',
  output_type_pin: 'Pin',
  carry_from: 'Carry From',
  edit_features: 'Add/Remove Features',
  add_feature: 'Add Feature',
  add_a_feature: 'Add a Feature',
  add_individual_features: 'Add Individual Features',
  remove_features_from: 'Remove Features from',
  add_features_to: 'Add Features to',
  resolve_conflicting_features: 'Resolve Conflicting Features',
  editing_vehicle: 'Editing Vehicle',
  add_or_remove_features_to_vehicle: 'Add/Remove Features To Vehicle',
  vehicle_banner_exit: 'Exit',
  exceeds_maximum_timers: (moduleType) =>
    `Exceeds the maximum number of Timers allowed for the ${moduleType}`,
  feature_already_on_vehicle:
    'A version of this Feature is already on the vehicle.',
  exceeds_maximum_timers_asam:
    'Exceeds the maximum number of Timers allowed for the ASAM',
  exceeds_maximum_logicsets_asam:
    'Exceeds the maximum number of Logic Sets allowed for the ASAM',
  exceeds_maximum_timers_xmc:
    'Exceeds the maximum number of Timers allowed for the XMC',
  exceeds_maximum_logicsets_xmc:
    'Exceeds the maximum number of Logic Sets allowed for the XMC',
  exceeds_maximum_switch_indicators_xmc: (moduleType) =>
    `Exceeds the maximum number of Switch Indicators allowed for the ${moduleType}`,
  exceeds_maximum_can_inputs_xmc: (moduleType) =>
    `Exceeds the maximum number of CAN Inputs allowed for the ${moduleType}`,
  only_one_feature_can_control_output:
    'Only one Feature can control a specific output on each vehicle',
  all_digital_input_instances_must_be_same_mode:
    'All instances of a specific Digital Input on a vehicle must be set to the same mode',
  remove_feature_tooltip: 'Remove Feature',
  remove_feature_as_built_tooltip: 'Remove As-Built Feature',
  remove_rp_tooltip: 'Remove Reference Parameter',
  add_feature_back_tooltip: 'Add Feature back',
  factory_defined_content_tooltip: 'Factory-defined content cannot be removed',
  feature_update_summary: 'Feature Update Summary',
  reason_for_conflict: 'Reason for Conflict',
  conflict_current_feature: 'Conflict (Current Feature)',
  conflict_new_feature: 'Confict (new Feature)',
  conflict_source: 'Conflict (Source Feature)',
  conflict: 'Conflict',
  conflict_with_feature: (featureId) =>
    `Feature ${featureId} is in conflict with features already on the vehicle.`,
  replace_current_with_new_feature: 'Replace Current with New Feature',
  keep_current_features: 'Keep Current Features',
  confirm_cancel_feature_edit: (
    <>
      <p style={{ marginBottom: 0 }}>
        You are about to abandon your progress. Are you sure
      </p>
      <p style={{ marginTop: 0 }}>
        you want to stop adding Features to this vehicle?
      </p>
    </>
  ),
  confirm_exit_rp_add_workflow: 'Are you sure you want to exit adding RPs?',
  comfirm_exit_ctp_workflow: 'Are you sure you want to cancel circuit mapping?',
  continue_updates: 'Continue Updates',
  cancel_updates: 'Cancel Updates',
  manage_fleet: 'Manage fleet',
  fleet_name: 'Fleet Name',
  lead_vehicle: 'Lead Vehicle',
  this_vehicle_parens: '(this vehicle)',
  view_vehicle: 'view vehicle',
  fleet_total: 'Fleet Total',
  shared_with: 'shared with',
  serviced_date: 'Serviced Date',
  back_to_feature_search: 'Back to Feature Search',
  logical_slot_range_error_msg:
    'Logical Slot No. range must be between 1-999 or 65535',
  lead: 'Lead',
  learn_more: 'Learn More',
  chec_proudly_supports: 'CHEC Proudly Supports',
  helpful_resources: 'Helpful Resources',
  how_to_search_for_a_feature: 'How to search for a Feature',
  duplicating_a_feature: 'Duplicating a Feature',
  adding_a_switch_to_the_dash: 'Adding a switch to the dash',
  add_a_switch: '+ Add a Switch',
  simulate_your_feature: 'Simulate your Feature',
  technical_resource_guides: 'Technical Resource Guides',
  create_a_feature_collection: 'Create a Feature Collection',
  adding_a_feature_to_a_vehicle: 'Adding a Feature to a vehicle',
  update_a_revised_feature: 'Update a revised Feature',
  apply_a_custom_switch_cap: 'Apply a custom switch cap',
  interface_connector_chart: 'Interface Connector chart',
  you_have_not_looked_at_any_vehciles_recently:
    'You have not looked at any vehicles recently',
  you_can: 'You can ',
  search_for_a_vehicle: 'search for a vehicle.',
  vehicle_features_update_failed_message: (
    <p>
      Something went wrong and CHEC was unable to save your changes. Please try
      again. To contact CHEC support, please submit a{' '}
      <a
        href={DTNA_CASE_MANAGEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'white' }}
      >
        DTTS/Salesforce
      </a>{' '}
      case.
    </p>
  ),
  vehicle_add_xmc_failed_message: (
    <p>
      Something went wrong and CHEC was unable to save your changes. Please try
      again. To contact CHEC support, please submit a{' '}
      <a
        href={DTNA_CASE_MANAGEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'white' }}
      >
        Salesforce
      </a>{' '}
      case.
    </p>
  ),
  vehciles_you_have_viewed_will_be_more:
    'Vehicles you have viewed will be here when you come back.',
  custom: 'Custom',
  pins_available: 'Pins Available',
  vehicle_added_to_favorites: 'You got it! Vehicle added to Favorites.',
  vehicle_removed_from_favorites: 'You got it! Favorite vehicle removed.',
  edit_favorites: 'Edit',
  done_editing: 'Done',
  custom_description: 'Custom Description',
  custom_description_placeholder: 'Add your custom description',
  no_custom_description: 'No custom description applied',
  yes_remove_it: 'Yes, Remove It',
  no_keep_it: 'No, Keep It',
  remove_favorite_confirmation:
    'Are you sure you want to remove this favorite?',
  remove_favorite_vehicle_confirmation: 'Remove Favorite Vehicle',
  previously_added_favorites: 'Previously added Favorites',
  favorite_vehicle_updated: 'You got it! Favorite vehicle updated.',
  favorite_removed_success: 'Vehicle removed from favorites.',
  success: 'Success',
  favorite_vehicles_tooltip:
    'Your favorite vehicles are here. You can:\n • View and access your favorites\n • Add your own custom vehicle descriptions\n • Edit your list',
  favorites: 'Favorites',
  comments: 'Notes',
  no_importable_support_parameters:
    'No Importable Support Parameters Associated with this Reference Parameter',
  mode: 'Mode',
  mode_0: 'M:0',
  mode_1: 'M:1',
  mode_2: 'M:2',
  timer_name: 'Timer Name',
  logic_set_name: 'Logic Set Name',
  timer_modes: Object.freeze({
    [M0]: 'Countdown and Restart',
    [M1]: 'Countdown and Hold',
    [M2]: 'Restart When Activate Lost',
  }),
  timer_mode_labels: Object.freeze({
    [M0]: 'M:0',
    [M1]: 'M:1',
    [M2]: 'M:2',
  }),
  timer_mode_numbers: Object.freeze({
    [M0]: '0',
    [M1]: '1',
    [M2]: '2',
  }),
  timer_mode_descriptions: Object.freeze({
    [M0]: [
      'When enabled, timer counts down from its initial value. When the count reaches “0”, timer will restart at "Max Value".',
      'While counting down, if the enable condition becomes false, the timer will hold its current value.If reset becomes true, the timer returns to and holds the initial value.',
    ],
    [M1]: [
      'When activated, the timer will count down from its initial value. When the count reaches “0”, the timer holds at “0”.',
      'While counting down, if the activate condition becomes false, the timer will hold its current value.If the reset condition is true at any time, the timer will return to and hold its initial value.',
    ],
    [M2]: [
      'When activated, the timer counts down from the initial value. When the count reaches “0”, the timer holds at “0”.',
      'If reset is true at any time, timer will return to and hold the initial value.',
    ],
  }),
  input_operator: 'Operator',
  digital_pin_input: 'DI Pin',
  analog_pin_input: 'AI Pin',
  carry_input: 'Carry',
  show_comparison: 'Show Comparison',
  feature_status_invalid_for_vehicle_addition:
    'Only Features with status “Test” or “Active” may be added to a vehicle',
  commit_to_fleet: 'Commit to Fleet',
  next_step_commit_to_fleet: 'Next Step: Commit to Fleet',
  fleet_update_warning_m2:
    'IMPORTANT: All selected vehicles will be programmed identical to the source vehicle.',
  fleet_update_warning:
    'Selected vehicles will be programmed identically to the source vehicle. Settings that do not match the source vehicle will be overwritten or deleted. These may include changes made to a vehicle’s Pneumatics (ECP) and Switch & Gauge inventory.',
  vehicle_not_part_of_fleet: 'Vehicle not part of a fleet.',
  lead_ref_params_invalid_status:
    'Reference Parameters on Source Vehicle must be in an "Active" or "Obsolete" status.',
  no_changes_have_been_made_to_vehicle:
    'No changes have been made to this vehicle.',
  select_source_vehicle_for_fleet_update:
    'Select the source vehicle for a fleet update',
  lead_vehicle_unchanged: 'No changes have been made to the Source Vehicle.',
  all_vehicles_updated: 'All vehicles in this fleet have been updated.',
  vehicles_will_not_be_updated:
    'The following vehicles have a Service Record and will not be updated:',
  vehicles_will_be_updated:
    'Adding PTO settings to the following vehicles should also be displayed:',
  added_vehicles_to_fleet_m2: (sourceVehicle) =>
    `Add settings from source vehicle ${sourceVehicle} to the fleet`,
  added_vehicles_to_fleet: (sourceVehicle) => (
    <>
      You are about to update the following vehicles with settings from{' '}
      <b>{sourceVehicle}</b> (source vehicle). Settings that do not match the
      source vehicle will be <b>overwritten</b> or <b>deleted</b>.
    </>
  ),
  activate_delay: 'Activate Delay',
  deactivate_delay: 'Deactivate Delay',
  query_operator_label: (operator) =>
    ({
      and: 'AND',
      or: 'OR',
      xor: 'XOR',
      toggle: 'Toggle',
    }[operator]),
  queries: 'Conditions',
  currently_in_progress: 'Currently in progress.',
  commit_to_fleet_in_progress: (fleetName) =>
    `${fleetName}: Commit to fleet in progress...`,
  commit_to_fleet_complete: (fleetName) =>
    `${fleetName}: Commit to fleet complete.`,
  commit_to_fleet_failed: (fleetName) =>
    `${fleetName}: Commit to fleet failed.`,

  // Fleet Update Banner strings
  fleet_update_note_prefix: 'Note:',
  fleet_update_success_prefix: 'You got it!',
  fleet_update_warning_prefix: 'Heads up:',
  fleet_update_for: 'The fleet update for',
  fleet_update_is_in_progress: 'is in progress',
  fleet_update_is_complete: 'is complete.',
  fleet_update_some_vehicles_failed: 'Some vehicles could not be updated.',
  fleet_update_vehicles_processed: (processed, total) =>
    `(${processed} of ${total} vehicles processed).`,

  // Fleet Update Modal strings
  fleet_update_modal_title: (fleetName) => `Fleet Update: ${fleetName}`,
  vehicles_processed_label: 'Vehicles processed:',
  vehicles_successfully_updated_label: 'Vehicles successfully updated:',
  vehicles_failed_to_update_label: 'Vehicles that failed to update:',
  no_vehicles_in_category: 'No vehicles in this category',
  lead_badge: 'Lead',

  redirect: 'Redirect',
  logic_gate_top: 'Logic Gate - Top',
  logic_gate_middle: 'Logic Gate - Middle',
  logic_gate_bottom: 'Logic Gate - Bottom',
  gates: 'Gates',

  // PBI 266671 - Logic Set Dynamic Palette Information
  learn_how_logic_set_works: 'Learn How This Logic Set Works',
  learn_how_logic_set_title: (logicSetName) =>
    `Learn how "${logicSetName}" operates`,
  select_element_for_details:
    'Select any element from the diagram or panel for details.',

  // Condition text templates
  condition_is_true_when: (signalName, operator, value) =>
    `Is TRUE when ${signalName} ${operator} ${value}`,
  condition_transitions_rising: 'transitions from FALSE to TRUE',
  condition_transitions_falling: 'transitions from TRUE to FALSE',
  condition_transitions_both: 'transitions from TRUE to FALSE or FALSE to TRUE',
  condition_with_hysteresis: (input, complementaryOp, releaseValue, unit) =>
    `and once met, remains TRUE until the ${input} ${complementaryOp} ${releaseValue}${
      unit ? ` ${unit}` : ''
    }`,

  // Carry text templates
  carry_logic_set_is_true: (carrySourceName, value = 'TRUE') =>
    `Is TRUE when ${carrySourceName} is ${value}`,
  carry_timer_is_true: (timerName, operator, value) =>
    `Is TRUE when ${timerName}'s value ${operator} ${value}`,

  // Logic Gate text templates
  logic_gate_and_text: (elementA, elementB) =>
    `Is TRUE when ${elementA} and ${elementB} are both TRUE`,
  logic_gate_or_text: (elementA, elementB) =>
    `Is TRUE when either ${elementA} or ${elementB} (or both) are TRUE`,
  logic_gate_middle_or_text: (elementA, elementB) =>
    `Is TRUE when ${elementA} or ${elementB} are TRUE (or both)`,
  logic_gate_xor_text: (elementA, elementB) =>
    `Is TRUE when either ${elementA} or ${elementB} are TRUE, but FALSE if both ${elementA} and ${elementB} are TRUE`,
  logic_gate_toggle_text: (elementA, elementB) =>
    `When ${elementA} becomes TRUE, the output of the gate toggles between TRUE and FALSE, depending on the previous output.\nWhen ${elementB} becomes TRUE, the output of the gate resets to FALSE`,

  // Delay text templates
  activate_delay_text: (timerValue) =>
    `Once the Middle Logic Gate is TRUE the output of the Logic Set will become TRUE ${timerValue} later.\nIf the Middle Logic Gate changes to FALSE before ${timerValue} have passed the Logic Set will remain FALSE`,
  deactivate_delay_text: (timerValue) =>
    `When the output of the Logic Set is TRUE and the Middle Logic Gate becomes FALSE, the output will be held TRUE for ${timerValue}.\nIf the Middle Logic Gate changes to TRUE before ${timerValue} have passed the Logic Set will remain TRUE and the deactivation delay will be reset`,

  // Element labels for tiles
  condition_number_label: (number) => `Condition ${number}`,
  activate_delay_label: 'Activate Delay',
  deactivate_delay_label: 'Deactivate Delay',
  feature_no: 'Feature No.',
  input_config: {
    [ACTIVE_HIGH]: 'Active High Digital Input',
    [ACTIVE_LOW]: 'Active Low Digital Input',
    [VOLT_0_18K5]: 'Analog Voltage Input 0-18.5V',
    [VOLT_0_6]: 'Analog Voltage Input 0-6V',
    [RES_0_100k]: 'Analog Resistive Input 0-100KΩ',
    [RES_0_500]: 'Analog Resistive Input 0-500Ω',
    [VOLT_0_16_rel]: 'Relative Analog Voltage 0-16V',
  },
  input_signal_limit: 'Input Signal Limit',
  signal_limit: 'Signal limit',
  dashboard: 'Dashboard',
  switch_id: 'Switch ID',
  ssid: 'SS ID',
  i_o_title: 'I/O',
  circuit_name: 'Circuit Name',
  number_of_bits: 'Number of Bits',
  byte: 'Byte',
  byte_lower: 'byte',
  bit: 'Bit',
  bits: 'Bits',
  starting_bit: 'Starting Bit',
  can_id: 'CAN ID',
  unrecognized_map_type: 'Unrecognized Map Type',
  timer: 'Timer',
  back_to: (target) => (target ? `Back to ${target}` : 'Back'),
  fleet_management_title: 'Fleet Management',
  timer_value: (hours, minutes, seconds) => {
    if (hours !== 0) {
      return `${hours}h ${minutes}m ${seconds}s`
    }
    if (minutes !== 0) {
      return `${minutes}m ${seconds}s`
    }
    return `${seconds}s`
  },
  // Full word version for delay texts (not abbreviated)
  timer_value_full: (hours, minutes, seconds) => {
    const parts = []
    if (hours !== 0) {
      parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`)
    }
    if (minutes !== 0) {
      parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`)
    }
    if (seconds !== 0 || parts.length === 0) {
      parts.push(`${seconds} ${seconds === 1 ? 'second' : 'seconds'}`)
    }
    return parts.join(' ')
  },
  timer_value_read_only: (hours, minutes, seconds) =>
    `${hours}:${minutes}:${seconds}`,
  error_boundary_header: 'CHEC Encountered an Error',
  error_boundary_api_header: 'CHEC Encountered a Network Error',
  chec_home: 'CHEC Home',
  controls: 'Controls',
  native_output: 'Native Output',
  initial_timer_value: 'Initial timer value',
  repeat_cycle_value: 'Repeat cycle value',
  map_possibly_plural: 'Map(s)',
  timer_possibly_plural: 'Timer(s)',
  logic_possibly_plural: 'Logic(s)',
  plc_possibly_plural: 'PLC(s)',
  can_possibly_plural: 'CAN(s)',
  add_logic_set: 'Add Logic Set',
  add_timer: 'Add Timer',
  add_analog_input: 'Add analog input',
  add_can_input: 'Add CAN input',
  add_native_input: 'Add Native input',
  add_digital_input_pin: 'Add DI Pin',
  add_analog_input_pin: 'Add AI Pin',
  no_input_selected: '+ Add Solenoid',
  new_logic_set: `Logic Set`,
  create_logic_set: 'Create a New Logic Set',
  logic_sets_available: 'Logic sets available ASAM',
  new_timer: `Timer`,
  create_timer: 'Create a New Timer',
  delete: 'Delete',
  clear: 'Clear',
  add_function: 'Add Function',
  add_output: 'Add Output',
  function: 'Function',
  function_name: 'Function name',
  school_bus_mode: 'School Bus Mode',
  school_bus: 'School Bus',
  school_bus_valid_modules_message:
    '"School Bus Mode" limits Features to XMCs 3-8, and bus-compatible switches.',
  delete_item_heading: (itemDescription) => `Delete ${itemDescription}?`,
  clear_item_heading: (itemDescription) => `Clear ${itemDescription}?`,
  delete_condition_explanation: `Deleting this condition cannot be undone.`,
  delete_logicset_explanation: `Deleting this Logic Set will delete the Logic set with all of its contents. This action cannot be undone.`,
  delete_timer_explanation: `Deleting this Timer will delete the Timer with all of its contents. This action cannot be undone.`,
  delete_output_explanation:
    'Deleting this Output will delete the Output with all of its contents. This action cannot be undone.',
  clear_feature_explanation:
    'Clearing this Feature will reset the contents. This action cannot be undone.',
  clear_output_explanation:
    'Clearing this Output will reset the contents to "undefined". This action cannot be undone.',
  clear_logicset_explanation:
    'Clearing this Logic Set will reset all Conditions to "undefined". This action cannot be undone.',
  clear_timer_explanation:
    'Clearing this Timer will reset all Conditions to "undefined". This action cannot be undone.',
  clear_can_input_explanation:
    'Clearing this Can Input will reset all Conditions to "undefined". This action cannot be undone.',
  clear_condition_explanation: 'Clearing this condition cannot be undone.',
  priority_title: 'Priority',
  n_a: 'N/A',
  n_a_lowercase: 'n/a',
  carry_only: 'CARRY ONLY',
  cannot_edit_carry_only:
    'Priority cannot be edited while the output is CARRY ONLY',
  priority_descriptions: [
    '1 = Lowest Priority',
    '5 = Highest Priority',
    '65535 = Carry Only(N/A)',
  ],
  required: 'Required',
  expand: 'Expand',
  collapse: 'Collapse',
  query: 'Query',
  select_output_query: 'Select Logic Set or Timer',
  timers: 'Timers',
  no_timers: 'No Timers',
  no_logic_sets: 'No Logic Sets',
  no_outputs: 'No Outputs',
  delete_function_warning_explaination:
    'Deleting this Function will delete its contents and notes. This cannot be undone.',
  bit_byte_output_label: (numBits) =>
    `Bit / Byte ${numBits === 2 ? 'Pair' : 'Block'}`,
  select_bit_byte_output_label: (numBits) =>
    `Select Bit / Byte ${numBits === 2 ? 'Pair' : 'Block'}`,
  bit_byte_pair: 'Bit / Byte Pair',
  bit_byte_input_label: (numberOfBits) => {
    const bitByte = 'Bit / Byte'

    if (numberOfBits === 1) {
      return bitByte
    }

    if (numberOfBits === 2) {
      return `${bitByte} Pair`
    }

    return `${bitByte} Block`
  },
  select_starting_bit_label: 'Select Starting Bit',
  can_input_description: (numberOfBits, canId) =>
    `CAN, ${numberOfBits} Bit: 0x${canId}`,
  define_new_can_id: '+ Define CAN ID',
  can_input: 'CAN Input',
  analog_input: 'Analog Input',
  analog_input_pin: 'Analog Input Pin',
  digital_input_pin: 'Digital Input Pin',
  native_input: 'Native Input',
  native_output_helper_text: "Because you're controlling a Native Output",
  native_output_helper_long_text:
    'Single inputs controlling a Native Output have limited settings. Configure the input via a Logic Set for additional settings.',
  switch_input: 'Switch Input',
  switch_input_type_label: 'Switch',
  switches: 'Switches',
  native_signal: 'Native Signal',
  switch_signal: 'Switch Signal',
  can_id_hex_16: 'CAN ID (Hex 16)',
  hex_num: (num) => `HEX: ${num}`,
  binary_num: (num) => `BIN: ${toInt(num) === 1 ? `0${num}` : num}`,
  virtual_fuse_setting: 'Virtual Fuse Setting',
  virtual_fuse_setting_hint: '0-20A',
  reset_fuse_setting: 'Reset Fuse Setting',
  ignition: 'Ignition',
  on_ignition: 'On Ignition',
  automatic: 'Automatic',
  automatic_short: 'Auto',
  reset: 'Reset',
  reset_virtual_fuse: 'Virtual Fuse Reset',
  reset_attempts: 'Reset Attempts',
  reset_timer: 'Reset Timer',
  available_reset_attempts: 'Available Reset Attempts',
  attempts: 'Attempts',
  attempts_lowercase: 'attempts',
  reset_attempts_hint: '0-15',
  unavailable_output_text_header:
    '16 Bit CAN output is not valid with this function.',
  unavailable_output_explanation: (
    <>
      {`To use this output as a 16 bit CAN output in this Feature, it must be in a new function.`}{' '}
      <br />
      <br />{' '}
      {`16 bit CAN outputs must receive data directly from a 16 bit CAN input or an analog input pin and be the only output in the function.`}
    </>
  ),
  panel_43N_right_hand_panel: 'Right Hand B Panel: (AUX, Switch and Gauge)',
  panel_43N_icu_panel: 'A Panel: ICU (Instrument Cluster)',
  outputting_to_label: 'Outputting Data To',
  input_from_label: 'Control Output With',
  input_from_label_hint: 'Available selections are based on output type',
  inputting_data_from_label: 'Inputting Data From',
  keep_as_module: (moduleName) => `Lock this Feature to ${moduleName}?`,
  lock_in_module_module_name: (moduleName) => (
    <>
      <p>{`You are about to move this Feature from "Design (New)" to "Test". This will lock the Feature to ${moduleName} and prevent it from being reassigned to a different ECU.`}</p>
      <p>{`Do you want to move this Feature to "Test"?`}</p>
    </>
  ),
  confirm_activate_feature_header: `Activate Feature?`,
  confirm_activate_feature_body:
    'By activating this Feature you are confirming that you have tested and verified that this Feature works as intended.',
  confirm_obsolete_feature_body: (
    <>
      <p style={{ whiteSpace: 'break-spaces', marginBottom: 0 }}>
        {`Changing the status of this Feature to “Obsolete” cannot be undone.

The Feature cannot be:
`}
      </p>
      <ul>
        <li>Returned to “Active” status</li>
        <li>Added to a vehicle</li>
        <li>Added to a Feature Collection</li>
      </ul>
    </>
  ),
  fleet_lead: 'Fleet Lead',
  this_vehicle: '(this vehicle)',
  solenoid: 'Solenoid',
  solenoid_module_label: 'Module (subgroup)',
  solenoid_circuit_label: 'Air Circuit',
  internal_collet_part_number_label: 'Collet Part No. (Daimler)',
  external_collet_part_number_label: 'Collet Part No. (Supplier)',
  collet_color_label: 'Collet Color',
  solenoid_location_label: 'Solenoid Location',
  brown: 'Brown',
  blue: 'Blue',
  red: 'Red',
  green: 'Green',
  black: 'Black',
  white: 'White',
  tan: 'Tan',
  yellow: 'Yellow',
  silver: 'Silver',
  purple: 'Purple',
  dark_green: 'Dark Green',
  orange: 'Orange',
  brown_upper: 'BROWN',
  blue_upper: 'BLUE',
  red_upper: 'RED',
  green_upper: 'GREEN',
  black_upper: 'BLACK',
  white_upper: 'WHITE',
  tan_upper: 'TAN',
  yellow_upper: 'YELLOW',
  silver_upper: 'SILVER',
  purple_upper: 'PURPLE',
  dark_green_upper: 'DARK GREEN',
  orange_upper: 'ORANGE',
  ecp: 'ECP',
  all_ecps: 'All ECPs',
  ecp_update_notification: 'ECP updates saved',
  solenoid_updates: 'Solenoid updates',
  select_solenoid_details: 'Select a solenoid to view details',
  switch_and_gauge_has_pending_banner:
    'Updates will remain as "Pending" until they have been programmed to DiagnosticLink.',
  pneumatics_has_pending_banner:
    'Updates to Pneumatics will remain as "Pending" until they have been programmed to DiagnosticLink. Click here for instructions.',
  pneumatics_ecp_pending_changes: 'Pending changes:',
  pneumatics_has_optional_solenoids_banner:
    'Solenoids controlled by a Feature on the vehicle were not installed. Click here for instructions.',
  pneumatics_optional_solenoids_title:
    'To add the following solenoids, manually adjust the inventory:',
  controlled_by_feature: 'Controlled by Feature',
  module_not_on_vehicle: (moduleName) =>
    `Cannot add, because this vehicle doesn't have an ${moduleName}`,
  not_authorized_to_add_module: `To add a Feature to a Factory-Controlled Module you must be an Internal Tier 3 or above.`,
  not_authorized_to_remove_module: `To remove a Feature on a Factory-Controlled Module you must be an Internal Tier 3 or above.`,
  feature_saved: 'Feature saved',
  solenoid_part_number_internal_label: 'Solenoid part No. (Daimler)',
  available_solenoid_tooltip: (
    <>
      <p
        style={{ margin: 0 }}
      >{`You can add any solenoid that hasn't been assigned.`}</p>
      <p
        style={{ margin: 0 }}
      >{`You cannot use the same solenoid in two locations.`}</p>
    </>
  ),
  summary: 'Summary',
  serial_number_hash: 'Serial #',
  resetting_switch_and_gauge: 'Reset Switch & Gauge',
  reset_will_clearP_all_unsaved_changes:
    'Resetting the dash will clear all unsaved changes on the dash panels. Are you sure you want to reset?',
  editing_switch_and_gauge: 'Editing Switch & Gauge',
  part_and_location_conflict: 'Part and Location Conflict',
  error_caused_by_the_following: 'Error caused by the following:',
  please_contact_chec_support_for_further_assistance:
    'Please contact CHEC Support for further assistance',
  chec_support_email: 'checsupport@daimlertruck.com',
  moved_the_following: 'Moved the following',
  switch_and_gauge_update_complete: 'Switch & Gauge update complete',
  drag_part_to_desired_location: 'Drag part to desired location.',
  history: 'History',
  obsolete_feature_title: 'Change this Feature’s status to “Obsolete”?',
  version_history: 'Version History',
  back_from_version_history: 'Back to Current Version',
  current_version: 'Current Version',
  full_history: 'See Full History',
  no_history: 'No historical record',
  open_in_new_window: 'Open in new window',
  all_panels: 'All Panels',
  empty: 'Empty',
  no_data: 'No Data',
  dash_configuration_error: (partNumbers) =>
    `Configuration error. Part/s: ${partNumbers}. Please contact CHEC Support for further assistance: checsupport@daimlertruck.com`,
  location: 'Location',
  feature_type: 'Feature Type',
  subgroup: 'Subgroup',
  priority: 'Priority',
  successor_code: 'Successor Code',
  successor_code_error: 'Must be 6 characters',
  feature_status: 'Feature Status',
  feature_status_new: 'Design (NEW)',
  feature_status_returned: 'Design (RETURNED)',
  feature_edit_priority_hint: '0-100',
  feature_edit_priority_tooltip:
    'Priority of floating content for the build process. 0 is the lowest priority and 100 is the highest.',
  feature_edit_successor_code_tooltip:
    'Data code for which this Feature supersedes previous content.',
  feature_edit_type_tooltip:
    'Internal Features are for Daimler use only. The Electronic Release System (ERS) number for the job in which this Feature part number resides.',
  feature_edit_subgroup_tooltip: 'The module number for the product area.',
  pre_production_banner_info: 'Pre-production vehicles are not editable.',
  no_diagnostic_variant_info:
    'Due to vehicle data issues with this specific unit, no changes can be made at this time. Please submit a DTTS/Salesforce case to have the issue fixed.',
  pre_production_swga_edit_banner_info: `Pre-production editing of Switch & Gauge is allowed on lead vehicles.`,
  view_lead_vehicle_banner_button: 'View Lead Vehicle',
  add_note_placeholder: 'Add a note',
  notes_counter: (num) => `${num} Note${num !== 1 ? 's' : ''}`,
  exact_num_chars_error: (num) => `Must be ${num} characters`,
  interface: 'Interface',
  not_found_error_message: 'No record was found for this vehicle.',
  interface_connectors: 'Interface Connectors',
  exterior_connector_label: 'Exterior Connector',
  exterior_connector_label_6: 'Powertrain Interface Connector',
  exterior_connector_label_5: 'Body Lighting Connector',
  interior_connector_label: 'Interior Connector',
  interior_connector_label_6: 'Powertrain Interface Connector',
  interior_connector_label_5: 'Body Lighting Connector',
  exterior_connector_btn_text: 'EXT',
  interior_connector_btn_text: 'INT',
  INT_interface: 'Interior Interface Connector',
  EXT_interface: 'Exterior Interface Connector',
  replaced_with: 'Replaced with',
  reset_ecp_message:
    'Resetting this ECP will clear all unsaved changes and reset it to the last saved configuration.',
  important_exclamation: 'Important!',
  ecp_update_header: 'ECP Update Summary',
  ecp_update_description_p1:
    'Ensure that the furthest right solenoid is Part No. 12-33711-001, and the rest are Part No. 12-33711-000.',
  ecp_update_description_p2:
    'By removing a solenoid from CHEC, you are verifying that you have physically adjusted the solenoids to match the record.',
  add_solenoid: '+ Add Solenoid',
  only_last_solenoid_is_removable: (pos) => (
    <>
      Only <strong>Position {pos}</strong> is Removable
    </>
  ),
  solenoids_added: 'Solenoids Added:',
  solenoids_removed: 'Solenoids Removed:',
  solenoids_moved: 'Solenoids Moved:',
  reset_ecp: 'Reset ECP?',
  available_solenoids: 'Available Solenoids',
  ecp_pending_modifications:
    'To access other ECPs, Save or Reset pending edits to the current ECP.',
  par_file_error_header: 'Error creating .PAR file',
  par_file_error_footer:
    'Please reconfigure your logic or contact CHEC support at checsupport@daimlertruck.com',
  par_file_error_unknown:
    'The .PAR file generation failed due to unknown reasons',
  par_file_error_unknown_footer:
    "Please try again. If this doesn't resolve the issue, please contact CHEC support at checsupport@daimlertruck.com",
  part: 'Part',
  added: 'Added',
  moved: 'Moved',
  removed: 'Removed',
  replaced: 'Replaced',
  updated: 'Updated',
  updated_to_latest_version: 'Updated to latest version',
  item: 'Item',
  action: 'Action',
  exm: 'EXM',
  parameter_edit: 'Parameter edit',
  dashboard_edit: 'Dashboard Edit',
  feature: 'Feature',
  switch_and_gauge_edit: 'Switch & Gauge Edit',
  limited_historical_data_on_this_item: 'Limited historical data on this item.',
  acquire_high: 'Acquire High',
  acquire_low: 'Acquire Low',
  ai: 'AI',
  table_dim_length: 'Table Dim Length',
  table_dim_2d_3d: 'Table Dim 2D/3D',
  z_sign: 'Z Sign',
  y_sign: 'Y Sign',
  x_sign: 'X Sign',
  z_byte: 'Z Byte',
  parameter_version: 'Parameter Version',
  Modal_number: 'Modal Number',
  logical_slot: 'Logical Slot',
  rowid: 'Row ID',
  parm_checksum_offset: 'Parm Checksum Offset',
  parm_address: 'Parm Address',
  parm_size: 'Parm Size',
  extra_block_1_address: 'Extra Block 1 Address',
  extra_block_1_size: 'Extra Block 1 Size',
  extra_block_2_address: 'Extra Block 2 Address',
  extra_block_2_size: 'Extra Block 2 Size',
  extra_block_3_address: 'Extra Block 3 Address',
  extra_block_3_size: 'Extra Block 3 Size',
  inverted: 'Inverted',
  not_inverted: 'Not Inverted',
  inversion: 'Inversion',
  length: 'Length',
  offset: 'Offset',
  physical_slot: 'Physical Slot',
  ai_ls: 'AI LS',
  do_ls: 'DO LS',
  do: 'DO',
  intercept: 'Intercept',
  reaction: 'Reaction',
  pc_inc: 'PC Inc',
  pc_dec: 'PC Dec',
  fault_intercept: 'Fault Intercept',
  fault_reaction: 'Fault Reaction',
  fault_pc_inc: 'Fault PC Inc',
  fault_pc_dec: 'Fault PC Dec',
  dtc_j1587_sid: 'J1587 SID',
  dtc_j1939_spn: 'J1939 SPN',
  dtc_j1587_fmi: 'J1587 FMI',
  dtc_j1939_fmi: 'J1939 FMI',
  j1587_sid: 'J1587 SID',
  j1939_spn: 'J1939 SPN',
  j1587_fmi: 'J1587 FMI',
  j1939_fmi: 'J1939 FMI',
  dtc_reaction: 'DTC Reaction',
  loss_low: 'Loss Low',
  loss_high: 'Loss High',
  task1: 'Task 1',
  task2: 'Task 2',
  task3: 'Task 3',
  task4: 'Task 4',
  task5: 'Task 5',
  task6: 'Task 6',
  task7: 'Task 7',
  output_id: 'Output ID',
  behavior_code: 'Behavior Code',
  test_time: 'Test Time',
  output_1: 'Output 1',
  output_2: 'Output 2',
  output_1_current_sense: 'Output 1 (Current Sense)',
  output_2_current_sense: 'Output 2 (Current Sense)',
  output_1_low_limit: 'Output 1 (Low Limit)',
  output_2_low_limit: 'Output 2 (Low Limit)',
  output_1_high_limit: 'Output 1 (High Limit)',
  output_2_high_limit: 'Output 2 (High Limit)',
  amps_a: 'A',
  true_abbr: 'T',
  false_abbr: 'F',
  evaluation: 'Evaluation',
  evaluate_when: 'Evaluate When',
  smart_switch: 'Smart Switch',
  tem_indicator: 'TEM Indicator',
  tem_custom_switch_name: 'TEM Custom Switch Name',
  custom_ai_pin_name: 'Custom AI Pin Name',
  custom_ai_pin_tooltip:
    'You can apply a new description to this Analog Input Pin.',
  custom_di_pin_name: 'Custom DI Pin Name',
  custom_di_pin_tooltip:
    'You can apply a new description to this Digital Input Pin.',
  custom_can_input_name: 'Custom CAN Input Name',
  custom_can_input_tooltip:
    'You can apply a new description to this CAN Input.',
  smartplex_input: 'Smartplex Input',
  smartplex_output: 'Smartplex Output',
  smart_plex_switch: 'SmartPlex Switch',
  smart_switch_movement_suffix:
    'can be moved to any available switch location on the dash. It can be swapped with any other switch, swapping with a Hardwired Switch is restricted to the current panel.',
  hardwired_component: 'Hardwired Component',
  hardwired_component_movement_suffix:
    'can only be moved to an available location on the current dash panel.',
  hardwired_switch_movement_suffix:
    'can only be moved to an available switch location on the current dash panel. Swapping is restricted to this panel.',
  evaluation_condition:
    'Condition is triggered when its Carry evaluates to True or False',
  evaluation_output:
    'Output is triggered when its Carry evaluates to True or False',
  evaluates_to: 'Evaluates to',
  signal_enabled: 'Enabled',
  signal_disabled: 'Disabled',
  signal_off: 'Off',
  signal_reserved_for_sae: 'Reserved For SAE',
  signal_on_solid: 'On Solid',
  signal_on_blink_fast: 'On Blink Fast',
  signal_on: 'On',
  signal_released: 'Released',
  signal_pressed: 'Pressed',
  signal_depressed: 'Depressed',
  signal_set: 'Set',
  signal_disengaged: 'Disengaged',
  signal_engaged: 'Engaged',
  signal_open: 'Open',
  signal_latched: 'Latched',
  signal_unlocked: 'Unlocked',
  signal_locked: 'Locked',
  signal_plus_12_volts: '+12V',
  signal_grounded: 'Grounded',
  signal_accessory: 'Accessory',
  signal_run: 'Run',
  signal_crank: 'Crank',
  signal_reverse: 'Reverse',
  signal_neutral: 'Neutral',
  signal_activated: 'Activated',
  signal_deactivated: 'Deactivated',
  signal_error: 'Error',
  signal_no_error: 'No Error',
  signal_sna: 'SNA',
  signal_marker_on: 'Marker On',
  signal_headlights_on: 'Headlights On',
  signal_headlights_markers_on: 'Headlights And Markers On',
  signal_auto: 'Auto',
  signal_delayed_off: 'Delayed Off',
  signal_trailer_detected: 'Trailer Detected',
  signal_trailer_not_detected: 'Trailer Not Detected',
  signal_trailer_alarm: 'Trailer Alarm',
  signal_intermittent_1: 'Intermittent 1',
  signal_intermittent_2: 'Intermittent 2',
  signal_intermittent_3: 'Intermittent 3',
  signal_intermittent_4: 'Intermittent 4',
  signal_intermittent_5: 'Intermittent 5',
  signal_low: 'Low',
  signal_high: 'High',
  signal_gear_1: 'Gear 1',
  signal_gear_2: 'Gear 2',
  signal_gear_3: 'Gear 3',
  signal_gear_4: 'Gear 4',
  signal_gear_5: 'Gear 5',
  signal_gear_6: 'Gear 6',
  signal_level_0: 'Level 0',
  signal_level_1: 'Level 1',
  signal_level_2: 'Level 2',
  signal_level_3: 'Level 3',
  signal_level_4: 'Level 4',
  signal_level_5: 'Level 5',
  signal_level_6: 'Level 6',
  signal_level_7: 'Level 7',
  signal_level_8: 'Level 8',
  signal_level_9: 'Level 9',
  signal_level_10: 'Level 10',
  signal_level_11: 'Level 11',
  signal_level_12: 'Level 12',
  signal_level_13: 'Level 13',
  signal_park: 'Park',
  signal_unavailable: 'Unavailable',
  signal_mph: 'MPH',
  signal_rpm: 'RPM',
  signal_v: 'V',
  ms: 'ms',
  signal_f: 'F',
  signal_fahrenheit: 'Fahrenheit',
  signal_kpa: 'kPa',
  hazard_lights: 'Hazard Lights',
  add_rps: 'Add/Replace RPs',
  adding_reference_parameter_to_vehicle: 'Editing Vehicle',
  rps_on: (serialNumber) => `RPs on ${serialNumber}`,
  search_rps: 'Add Individual RPs',
  search_show_rps: 'Only Show Compatible RPs',
  rp_collections: 'RP Collections',
  rp_collections_description:
    "Collections can be used to quickly apply RP's to a vehicle.",
  rp_collection_created_before_part_number: 'Created before 05/04/2026',
  use_rp_collection: 'Use an RP Collection',
  save_new_collection: 'Save as a New Collection',
  add_rp_collection_modal_header: (serialNumber) =>
    `Make a new RP Collection from the following Reference Parameters on ${serialNumber}?`,
  save_collection: 'Save Collection',
  select_collection: 'Select Collection',
  review_rp: 'Review RPs',
  commit: 'Commit',
  commit_changes: 'Commit Changes',
  add_remove_rp_to_vehicle: 'Add/Replace RP to Vehicle',
  exit_rp: 'Exit RPs',
  search_collections: 'Search Collections',
  collection_title: 'Collection Title',
  collection_description: 'Collection Description',
  enter_title: 'Enter a title',
  enter_description: 'Enter a description',
  commit_to_vehicle: 'Commit to Vehicle',
  validating_features: 'Checking Features',
  add_rp: 'Add RP',
  already_on_vehicle: 'Already on vehicle',
  switch_already_on_vehicle: 'This switch is already on the vehicle.',
  unmapped_circuits: (num) => `Unmapped Circuits: ${num}`,
  pins_not_for_circuits:
    'Pins are not available on this vehicle for the following circuits',
  input_pin_on: (module) => `Input Pin on ${module}`,
  not_available: 'Not Available',
  rp_no: 'RP No.',
  replacing: 'Replacing',
  added_reference_parameters: 'Added Reference Parameters',
  added_reference_parameters_error: (errCode, errMessage) =>
    `Unable to add Reference Parameters: Error (${errCode} ${errMessage})`,
  signal_ohm: 'Ω',
  signal_kohm: 'kΩ',
  signal_percent: '%',
  signal_relative_voltage_label: 'Percentage',
  signal_volts_label: 'Volts',
  resistance_label: 'Resistance',
  voltage_label: 'Voltage',
  measure_label: 'Measure',
  scaling_measure_label: 'Scaling Measure',
  relative_voltage_label: 'Relative Voltage',
  signal_relative_voltage_tooltip:
    'In this mode, the AI Pin measures a voltage between 0-16V and compares it to the present battery reference.\n\nExample 1\nAI Pin = 4V, Battery at 12V, therefore, pin is 25% of battery voltage.\n\nExample 2\nAI Pin = 16V, Battery at 12V, therefore, pin is 133.3% of battery voltage.',
  signal_measure_tooltip: `In this mode the AI Pin measures the resistance between itself and its reference ground pin.`,
  continue_add_rps: 'Continue Adding',
  cancel_add_rps: 'Cancel Add RP',
  ctp_mapping_modal_header: (rp, serialNumber) =>
    `RP ${rp} requires circuit mapping to vehicle ${serialNumber}`,
  pin_requires_mapping: 'Pin requires mapping',
  select_type_pin: (type, circuit) =>
    `Select ${type} pin for Circuit ${circuit}`,
  cancel_mapping: 'Cancel Mapping',
  continue_mapping: 'Continue Mapping',
  num_circuits_added: (number) => `${number} Circuits Added`,
  switch_position_upper: 'Switch Position Upper',
  switch_position_lower: 'Switch Position Lower',
  up_position_only: 'This Custom Switch only has an "Up" position',
  asam_current_5A_only: 'Only 5A is available for the selected ECU (ASAM).',
  switch_indicator: 'Switch Indicator',
  switch_indicators: 'Switch Indicators',
  remove_updated_feature:
    'Removing this Feature removes all versions of this Feature from the vehicle',
  cannot_removed_feature: 'Feature cannot be removed',
  cannot_add_back_reason_logic_sets: (module, numLogicSets) =>
    `Cannot add back to vehicle because it will exceed the maximum number of Logic Sets (${numLogicSets}), for ${module}`,
  cannot_add_back_reason_timers: (module, numTimers) =>
    `Cannot add back to vehicle because it will exceed the maximum number of Timers (${numTimers}) for ${module}`,
  cannot_add_back_reason_both: (module, numLogicSets, numTimers) =>
    `Cannot add back to vehicle because it will exceed the maximum number of Logic Sets (${numLogicSets}), and the maximum number of Timers (${numTimers}) for ${module}`,
  cannot_update_reason_logic_sets: (module, numLogicSets) =>
    `Cannot update to the new version because it will exceed the maximum number of Logic Sets (${numLogicSets}), for ${module}`,
  cannot_update_reason_timers: (module, numTimers) =>
    `Cannot update to the new version because it will exceed the maximum number of Timers (${numTimers}) for ${module}`,
  cannot_update_reason_both: (module, numLogicSets, numTimers) =>
    `Cannot update to the new version because it will exceed the maximum number of Logic Sets (${numLogicSets}), and the maximum number of Timers (${numTimers}) for ${module}`,
  newer_feature_version_available_here:
    'A newer version of this Feature is available here:',
  is_most_recent_version: 'This is the most recent version of this Feature.',
  active_revision_has_newer_version:
    'This is not the most recent version of this Feature.',
  revision_go_newest: 'Go To Next Version',
  revision_go_second_newest: 'Go To Previous Version',
  newer_feature_version_available:
    'A newer version of this Feature is available',
  common_node_conflict: 'Unavailable (this common node pin is in use)',
  reference_parameter_requires_mapping_that_is_pending:
    'This Reference Parameter requires circuit mapping that is currently in pending status with another staged RP, and does not require any additional mapping.',
  view_mapping: 'View Mapping',
  new_version_commit_title:
    'Updating to the newest version of the following Features:',
  adding_commit_title: 'Adding the following Features:',
  removing_commit_title: 'Removing the following Features:',
  features_outdated_banner:
    'Changes were made to Features used on this vehicle. You can update them to the newest versions.',
  feature_cannot_send_to_test_banner:
    'To move this Feature to "Test" some issues require your attention.',
  feature_cannot_save_banner:
    'To save this Feature some issues require your attention.',
  duplicate_native_output_assignment:
    'The same Native Output cannot be assigned to multiple outputs within a Feature.',
  activate_remove_unused_items:
    'Activating this Feature will remove the following non-configured items:',
  select_criteria: 'Select criteria',
  select_value: 'Select a value',
  select_sp: 'Select Support Parameter Type',
  switch_part_no: 'Switch Part No',
  sp_type: 'SP Type',
  vehicle_type: 'Vehicle Type',
  row_id_filter_chip: 'Row ID',
  advaned_filters: 'Advanced Filters',
  active_filters: 'Active Filters',
  search_tips_point_1: 'Search by entering either a number or keywords.',
  search_tips_point_2:
    'Using quotes around keywords returns results where they are together, ie. "park brake"',
  search_tips_point_3:
    'Exclude a term from results with the minus (-) symbol before the word, ie. "-word"',
  results_with_total: (total) => `Search results (${total})`,
  percent_100: '100%',
  percent_75: '75%',
  percent_50: '50%',
  fit_canvas_width: 'Fit canvas width',
  unique_description_validation: 'description must be unique',
  must_be_6_chars_validation: 'must be 6 chars',
  activate_condition_validation: 'activate condition required',
  one_condition_validation: 'one condition required',
  alphanumeric_validation: 'must be alphanumeric',
  pos: 'Pos.',
  pnl_first_group: 'First group to shut off',
  pnl_second_group: 'Second group to shut off',
  pnl_third_group: 'Third group to shut off',
  pnl_last_group: 'Last group to shut off',
  power_net_level: 'Power Net Level',
  power_net_and_voltage_conditions: 'Power Net and Voltage Conditions',
  power_net_simulated_level: (level) => `Simulated Power Net level: ${level}`,
  battery_voltage_value: 'Battery Voltage Value',
  engine_speed: 'Engine Speed',
  engine_state: 'Engine State',
  ignition_status: 'IGN Key State',
  none: 'None',
  dismiss: 'Dismiss',
  reset_delay: 'Reset Every',
  reset_delay_hint: '0 sec - 4 min',
  every: 'every',
  na: 'N/A',
  part_no: 'Part No.',
  ers_release_format_required: 'ERS release format required',
  feature_timer_countdown_start_text:
    'When activated, the timer counts down from its Initial Value.',
  feature_timer_reach_zero_restart_text:
    'When the count reaches 0.0s, the timer restarts from its Initial Value.',
  feature_timer_reach_zero_hold_text:
    'When the count reaches 0.0s, the timer holds at 0.0s.',
  feature_timer_activate_restart_text:
    'If the Activate Condition becomes false, the timer resets to its Initial Value and holds.',
  feature_timer_activate_hold_text:
    'If the Activate Condition becomes false, the timer holds its current value.',
  feature_timer_reset_text:
    'If the Reset Condition becomes true at any time, the timer will return to its Initial Value and holds.',
  activated: 'activated',
  its_initial_value: 'its Initial Value',
  admin: 'Admin BHM',
  engineer: 'Tier 3 BHM',
  developer: 'Tier 2 BHM',
  technician: 'Tier 1 BHM',
  plus_admin: 'Admin CEEA+',
  plus_engineer: 'Tier 3 CEEA+',
  plus_developer: 'Tier 2 CEEA+',
  plus_technician: 'Tier 1 CEEA+',
  viewer: 'Tier 0 BHM',
  plus_viewer: 'Tier 0 CEEA+',
  builder: 'Builder',
  internal_role_name: 'Internal',
  edit_own_role_name: 'Role Editor',
  chec_dev: 'CHEC Dev Features',
  feature_created: 'Feature created',
  fixed_duty_cycle_and_frequency: 'Fixed Duty Cycle and Frequency',
  variable_duty_cycle: 'Variable Duty Cycle',
  variable_frequency: 'Variable Frequency',
  pwm_mode: 'Mode',
  scaling_input: 'Scaling Input',
  scaling_input_min: 'Scaling Input Min',
  scaling_input_max: 'Scaling Input Max',
  pto: 'PTO',
  pto_domain: 'PTO Domain',
  domain_name: 'Domain Name',
  diagnostic_variant: 'Diagnostic Variant',
  app_variant: 'App Variant',
  minimum_diagnostic_variant: 'Minimum Diagnostic Variant',
  apply_pto_template: 'PTO Templates',
  pto_template_search_placeholder: 'Search Daimler PTO Templates',
  pto_template_search_placeholder_custom: 'Search Custom PTO Templates',
  pto_template_search_sort_by: 'Sort by:',
  pto_template_search_sort_label_newest_first: 'Newest first',
  pto_template_search_sort_label_oldest_first: 'Oldest first',
  pto_template_search_sort_label_title_asc: 'Title (A to Z)',
  pto_template_search_sort_label_title_desc: 'Title (Z to A)',
  pto_template_incompatible: 'Incompatible',
  pto_template_compatible_app_variants: (variants) => (
    <>
      This PTO Template is compatible with these Diagnostic Variants:
      <ul style={{ margin: 0 }}>
        {variants.map((variant) => (
          <li key={variant}>{variant}</li>
        ))}
      </ul>
    </>
  ),
  pto_template_edit_template: 'Edit PTO Template',
  pto_template_commit_added_settings: 'Added the following settings',
  pto_template_commit_updated_settingss: 'Updated the following settings',
  pto_template_commit_removed_settings: 'Removed the following settings',
  pto_template_no: 'Template No.',
  pto_template_author: 'Author',
  pto_template_creation_date: 'Creation Date',
  pto_template_name: 'Name',
  pto_template_model: 'Model',
  pto_template_created: 'Created',
  pto_template_type: 'Template Type',
  pto_template_source_transmission: 'Source Transmission',
  pto_template_source_engine: 'Source Engine',
  pto_template_all_templates: 'All PTO Templates',
  pto_template_domain_settings: 'Template Domain Settings',
  pto_template_all_domain_settings: 'All Domain Settings',
  pto_template_has_no_settings_from_domain:
    'This template does not contain any settings for this Domain',
  pto_template_search_filter_template_source: 'Template Source',
  pto_template_search_filter_template_model: 'Model',
  pto_template_search_filter_template_engine: 'Engine',
  pto_template_search_filter_template_transmission: 'Transmission',
  pto_template_filtered_settings_info:
    '"Template Domain Settings" presents only settings that are included in the template',
  pto_template_all_settings_info:
    '"All Domain Settings" presents all available Domain settings based on the Diagnostic Variant',
  pto_template_refno_not_included_in_template:
    'This Reference Number is not included in the template',
  pto_template_search_results_for: (string) => `Search results for "${string}"`,
  pto_template_search_results: 'Search results',
  feature_incompatible: 'Incompatible',
  exit_pto_templates: 'Exit PTO Templates',
  template_config_already_on_vehicle:
    'The content of this PTO template is already on the vehicle.',
  pto_default_fragment_value_warning: (value, units) => (
    <>
      This value was set outside of CHEC and exists outside of the permissible
      range. If you update and save this value, you will not be able to return
      it to its original setting{' '}
      <strong>
        ({value} {units})
      </strong>
    </>
  ),
  pto_template_add_to_template: 'Add to Template',
  pto_template_remove_from_template: 'Remove From Template',
  pto_template_add_this_setting_to_template:
    'Add this setting to your template?',
  pto_template_remove_this_setting_from_template:
    'Remove this setting from your template?',
  pto_template_you_are_adding_fragment_to_template: (fragmentName) => (
    <>
      <p>
        You are adding the setting for <strong>{fragmentName}</strong> to this
        PTO Template.
      </p>
      <p>
        Applying this template to vehicles will update any existing setting for
        the Domain Reference Number.
      </p>
      <p>Do you want to add this setting to the template?</p>
    </>
  ),
  pto_template_you_are_removing_fragment_from_template: (fragmentName) => (
    <>
      <p>
        You are removing the setting for <strong>{fragmentName}</strong> from
        this PTO Template.
      </p>
      <p>Do you want to remove this setting from the template?</p>
    </>
  ),
  template_create_date_prior_to_part_number: 'Created prior to 10/20/2022',
  apply_pto_template_button: 'Apply PTO Template',
  select_template: 'Select Template',
  apply_template: (id) => `Apply "${id}" Template`,
  create_template: 'Create Template',
  pto_templates: 'PTO Templates',
  pto_template: 'PTO Template',
  apply_pto_template_action_bar: 'Apply PTO Template',
  no_compatible_pto_templates:
    'There are no compatible templates for this vehicle at this time',
  no_diff_apply_pto_template:
    'All the contents of this template are already on the vehicle, no changes are available for your current PTO configuration.',
  apply_pto_banner_message:
    'A PTO Template will replace your current PTO configuration with the selected PTO configuration.',
  setting: 'Setting',
  setting_name: 'Setting Name',
  reference: 'Reference',
  unit: 'Unit',
  engine: 'Engine',
  transmission: 'Transmission',
  Modal: 'Model',
  dashboard_tables_order: 'Dashboard Tables Order',
  all_settings_saved: 'All User settings saved.',
  all_settings_save_error: 'All User setings save Error.',
  settings_type: 'Settings Type',
  setting_saved: (setting) =>
    setting ? `User Setting ${setting}, Saved.` : `User Setting Saved.`,
  setting_save_error: (setting) =>
    setting
      ? `User Setting ${setting}, Save Error.`
      : 'User Setting Save Error',
  pwm_mode_tooltip:
    'When a variable mode is selected, the output will scale proportionally to the selected input.',
  pwm_mode_equation_begin: 'Output = (InputValue - InputMax)',
  pwm_mode_equation_dividend: '(VariableMax - VariableMin)',
  pwm_mode_equation_divisor: '(InputMax - InputMin)',
  cap_part_no: 'Cap Part No.',
  cap_description: 'Cap Description',
  cap_description_title_case: 'Cap Description',
  part_number: 'Part Number',
  ref: 'Ref.',
  closest_values: 'Closest available values:',
  edit_pto_domain: 'Edit PTO Domain',
  reset_pto_settings: 'Reset PTO Settings',
  reset_pto_settings_description:
    'Resetting will clear all unsaved changes to your PTO settings',
  updated_the_following_settings: 'Updated the following settings:',
  updated_the_following_out_of_range_settings:
    'Updated the following out-of-range factory settings:',
  out_of_range: '(out-of-range factory setting)',
  pto_updated_toast: 'PTO settings updated',
  pto_updated_toast_fail: 'PTO settings failed to save',
  pto_has_domain_pending_banner:
    'Updates to PTO settings will remain as "Pending" until they have been programmed to DiagnosticLink.',
  domain: 'Domain',
  domains_with_pending_settings: 'PTO Domains with pending settings',
  pto_setting: 'PTO setting',
  pto_value_on_vehicle: 'Value on Vehicle',
  pto_value_on_template: 'Value on Template',
  restricted: 'Restricted',
  restrictedModulesNotification: (
    <p>
      ASAM, XMC 1, and XMC 2 Features are reserved for factory-defined content
      and data is for reference only.{' '}
      <a
        href={DTNA_CASE_MANAGEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#0051c4' }}
      >
        Create a DTTS/Salesforce case
      </a>{' '}
      related to CAC if you have any questions.
    </p>
  ),
  no_conflicts: 'No conflicts',
  refNo: 'Ref No.',
  boundaries: 'Boundaries',
  lower_boundary: 'Lower Boundary',
  upper_boundary: 'Upper Boundary',
  enables: 'Enables',
  settings: 'Settings',
  modules: 'Modules',
  setting_desc: 'Description',
  fragment_value_explanation:
    'Value must be between the highest value of the lower boundary and the lowest value of the upper boundary',
  continue_and_add_switch: 'Continue & Add Switch',
  there_is_no_available_space_on_msf:
    'There is no available space on your MSF for the following switches that will be added with this feature',
  switches_used_will_be_added_to_inventory:
    'Switches used by this feature will be added to the vehicle inventory',
  switch_description: 'Switch Description',
  the_following_switches_will_be_added:
    "The following switches will be added to your vehicle's inventory:",
  you_can_assign_locations_from:
    'You can assign location from the Switch & Gauge section of CHEC.',
  switches_with_no_assigned_locations: 'Switches with no assigned locations',
  true_question: 'TRUE?',
  remove_switch: 'Remove Switch',
  remove_this_switch: 'Remove This Switch',
  remove_switch_helper: 'You are removing this switch from the dash.',
  remove_switch_save_warning: 'Removal is final once dash changes are saved.',
  the_following_features_will_be_removed:
    'The following Features will be removed',
  add_component: '+ Add',
  add_switch: 'Add a Switch',
  engagement_criteria: 'ENGAGEMENT CRITERIA',
  interlocks: 'INTERLOCKS',
  pto_template_appvariant:
    'This template uses an incompatible software version to the vehicle.',
  detroit: 'DETROIT',
  allison_eaton: 'ALLISON / EATON',
  solenoid_control: 'SOLENOID CONTROL',
  feedback: 'FEEDBACK',
  analog_input_feedback: 'Feedback',
  pto1_engaged_feedback: 'PTO1 engaged feedback',
  pto2_engaged_feedback: 'PTO2 engaged feedback',
  pto3_engaged_feedback: 'PTO3 engaged feedback',
  solenoid_control_pto1_description_1: 'PTO1 solenoid ASAM X7-28',
  solenoid_control_pto2_description_1: 'PTO2 solenoid ASAM X7-31',
  solenoid_control_description_2: 'To ECP Engg solenoid',
  solenoid_control_description_3: 'PTO engaged messages',
  diagram_view: 'Diagram View',
  table_view: 'Table View',
  removed_the_following: 'Removed the following',
  added_the_following: 'Added the following',
  cavity: 'Cavity',
  wire_gauge: 'Wire Gauge',
  color: 'Color',
  harnesses: 'Harnesses',
  undefined: 'Undefined',
  undefined_condition: '- Undefined -',
  rev: 'Rev',
  no_results: 'No Results',
  no_results_returned:
    'Your search returned no results. Please check your spelling or try a different search term.',
  create_a_feature: 'Create a Feature',
  advanced_settings: 'Advanced Settings',
  change_ecu_heading: (ecu) => `Change ECU to ${ecu}?`,
  change_ecu_subheading: (
    <>
      {`Changing the ECU will remove the associated harnesses.`}
      <br />
      {`You will have to assign different harnesses to this feature.`}
    </>
  ),
  harness_display_in_list: ({ partNumber, revision }) => {
    if (revision === '-') return partNumber
    return `${partNumber}, Rev ${revision}`
  },
  keep_ecu_and_harnesses: 'Keep ECU',
  change_ecu_and_harnesses: 'Change ECU',
  harness: 'Harness',
  harnesses_compatible_with_module: (module) =>
    `Harnesses compatible with ${module}`,
  edit_release_notes: 'Edit Release Notes',
  create_release_title: (release) => `Release ${release}`,
  create_next_release_title: (release) => `Next Release ${release}`,
  upcoming_release: 'Upcoming release',
  vehicle_notification_resource_conflict: (type) =>
    `This vehicle uses too many ${type}. To program this vehicle, you must replace existing RPs with RPs that have fewer ${type}.`,
  unique_mlogic_to_be_added_or_removed: 'Unique MLogic to be added or removed.',
  if_the_same_mlogic_exist_on_a_different_rp:
    'If the same MLogic exists on a different RP on this vehicle, it will not be displayed here',
  unique_timer_to_be_added_or_removed: 'Unique Timer to be added or removed.',
  if_the_same_timer_exist_on_a_different_rp:
    'If the same Timer exists on a different RP on this vehicle, it will not be displayed here',
  will_be_removed: 'Will be removed',
  used_by_these_rps: 'Used by these RPs',
  release_note_saved: 'Release note saved.',
  failed_to_save_release_note: 'Release note not saved. See console for error.',
  revision_subtitle: (revision) => `Rev ${revision}`,
  revision_create_tooltip:
    'Advanced users can create a new version of an Active Feature. New versions will retain the Feature number.',
  revision: 'Revision',
  revision_short: 'Rev',
  revision_short_dot: 'Rev.',
  create_revision: 'Create Revision',
  feature_display_with_revision: ({ partNumber, revision }) => {
    if (!revision) return partNumber
    return `${partNumber}, Revision ${revision}`
  },
  date_format: 'Format DD MMM YYYY (07 July 1978)',
  get_harnesses_failure:
    'Harnesses failed to load, please refresh to try again',
  must_assign_harness: 'Must assign a valid harness for this pin',
  mlogic_to_be_added: 'MLogic to be added to vehicle config',
  mlogic_to_be_removed: 'MLogic this RP removes',
  timers_to_be_added: 'Timers to be added to vehicle config',
  timers_to_be_removed: 'Timers this RP removes',
  mlogic_on_vehicle: 'MLogic on vehicle',
  timers_on_vehicle: 'Timers on vehicle',
  pto_solenoid_1: 'PTO Solenoid 1',
  pto_solenoid_1_feedback: 'PTO Solenoid 1: Feedback',
  pto_solenoid_2: 'PTO Solenoid 2',
  pto_solenoid_2_feedback: 'PTO Solenoid 2: Feedback',
  pto_solenoid_3: 'PTO Solenoid 3',
  pto_solenoid_3_feedback: 'PTO Solenoid 3: Feedback',
  engine_mount_1: 'Engine Mount 1',
  engine_mount_1_feedback: 'Engine Mount 1: Feedback',
  engine_mount_2: 'Engine Mount 2',
  engine_mount_2_feedback: 'Engine Mount 2: Feedback',
  throttle_lock_request_xmc: 'Throttle lock request XMC',
  pto_release_section: 'PTO RELEASE SECTION',
  service_brake_interlock: 'SERVICE BRAKE INTERLOCK',
  park_brake_interlock: 'PARK BRAKE INTERLOCK',
  neutral_gear_interlock: 'NEUTRAL GEAR INTERLOCK',
  throttle_locked: 'Throttle Locked',
  set_speed_request: 'Set Speed Request',
  max_engine_speed: 'Max Engine Speed',
  wesc_status: 'Work Mode Status',
  wesc_governor_type: 'Work Mode Governor Type',
  wesc_status_label: 'WORK MODE STATUS',
  wesc_governor_type_label: 'WORK MODE GOVERNOR TYPE',
  throttle_locked_label: 'THROTTLE LOCKED',
  limits_tooltip_text: 'Update the text here',
  working_engine_speed_control: 'Working Engine Speed Control',
  fixed_engine_speed_control: 'Fixed Engine Speed Control',
  remote_engine_speed_control: 'Remote Engine Speed Control',
  pto_error_banner_message: (domain, settingName, error) =>
    `Domain: ${domain}, Setting: ${settingName} ${error}`,
  save_failed_with_description: (description) => `Save failed: ${description}`,
  save_failed: 'Save failed',
  base_number_already_staged: 'Base number already staged',
  engine_speed_control_and_gate_tooltip:
    'These five signals require speed control request from the specific "release" section and a solenoid activate signal from the same "release" section.',
  mlogics: 'MLogics',
  fixed_pin: 'Fixed Pin',
  floating_circuit: 'Floating Circuit',
  feature_circuit_tooltip:
    "A circuit to pin relationship is unavailable with the vehicle's current harness inventory",
  required_field_has_no_value: (label) =>
    `Requried field ${label} has no value`,
  orphans: 'Orphans',
  pto1: 'PTO 1',
  pto2: 'PTO 2',
  pto3: 'PTO 3',
  empto1: 'Engine Mt. PTO 1',
  empto2: 'Engine Mt. PTO 2',
  empto: 'Engine Mt. PTO',
  pto_diagram_all: 'Entire Diagram',
  only_show_enabled_settings: 'Only show enabled settings',
  remote_set_speeds: 'REMOTE SET SPEEDS',
  icu_set_speeds: 'ICU SET SPEEDS',
  cruise_control_speed_adjustment: 'CRUISE CONTROL SPEED ADJUSTMENT',
  engagement_interlocks: 'ENGAGEMENT INTERLOCKS',
  powertrain_limits: 'POWERTRAIN LIMITS',
  powertrain_limits_detroit: 'POWERTRAIN LIMITS, DETROIT',
  default_pto_engine_speed_limits: 'Default PTO Engine Speed Limits',
  advanced_limits: 'Advanced Limits when "Other" criteria is met',
  set_speed_settings: 'Set Speed Settings',
  pto1_summary: 'PTO1 Summary',
  pto2_summary: 'PTO2 Summary',
  pto_setting_compatible_powertrain:
    'Setting is not compatible with powertrain',
  empto_summary: 'Engine Mount PTO Summary',
  pto_settings_summary: 'PTO Settings Summary',
  all_pto_settings: 'All PTO Settings',
  no_enabled_settings: 'No Enabled Settings',
  engagement_request: 'ENGAGEMENT REQUEST',
  engagement_control: 'Engagement Control',
  pto_status: 'PTO STATUS',
  display_all_possible_locations: 'Display all possible locations',
  floating_circuit_mask: (circuit) => `Floating Circuit: ${circuit}`,
  floating_circuit_label: (circuit) => `Floating Circuit ${circuit}`,
  dash_builder: 'Dash Builder',
  prevent_duplicate_master_32ap1_reference_param:
    'Cannot update Reference Parameter with a Master number of 32AP1 because it may cause unexpected behavior in the BHM or RVM.',
  simulator_mode_banner:
    'Simulator Mode: Inputs in the canvas area reflect your simulated logic.',
  exit_simulator_mode: 'Exit Simulator Mode',
  simulate: 'Simulate',
  simulated_value_title: 'Simulated Value',
  logic_input: 'Logic Input',
  to_simulate_logic_tooltip:
    'To simulate Logic, you must save or cancel your changes',
  simulate_outputs_not_supported:
    'Outputs are not yet supported in simulation mode.',
  simulate_digital_input_not_supported:
    'Digital Input Pins are not yet supported in simulation mode.',
  simulate_analog_input_not_supported:
    'Analog Input Pins are not yet supported in simulation mode.',
  simulate_native_input_not_supported:
    'Native Inputs are not yet supported in simulation mode.',
  simulate_can_input_not_supported:
    'CAN Inputs are not yet supported in simulation mode.',
  simulate_switch_input_not_supported:
    'Switch Inputs are not yet supported in simulation mode.',
  reset_to_evaluation: 'Reset to "Evaluation"',
  floating_circuit_disabled_tooltip:
    'To assign a floating circuit, a harness with floating circuits must be assigned to this Feature',
  circuit_type_as_assigned: '(Original circuit, updated location)',
  pause_simulation_to_advance:
    'Pause simulation to advance simulation by one cycle',
  pause_simulation_to_reset: 'Pause simulation to reset time-based values',
  unsupported_vehicle_type:
    'is a vehicle type not supported by CHEC. Please search for another vehicle.',
  parts_without_locations: 'Parts Without Locations',
  parts_with_unknown_locations: 'Parts with unknown locations',
  panel_matrix_not_found: 'Panel matrix not found.',
  panel_location_used: 'Panel location used.',
  panel_location_blocked: 'Panel location blocked.',
  asam_version: 'ASAM Version',
  xmc_1_version: 'XMC 1 Version',
  xmc_2_version: 'XMC 2 Version',
  xmc_3_version: 'XMC 3 Version',
  xmc_4_version: 'XMC 4 Version',
  loading_fleet_information:
    'Loading fleet information, this may take a minute or longer.',
  the_following_switches_will_be_removed:
    "The following switches will be removed from your vehicle's inventory:",
  hardwired_switch: 'Hardwired Switch',
  custom_hardwired_switch: 'Hardwired Switch (Custom Cap)',
  components_without_locations:
    'There are parts without locations that cannot be programmed to the vehicle until you add them to the dash.',
  displaying_allium_data: 'Displaying Allium data',
  saved_with_allium_errors:
    'Successfully saved to Allium but with errors, check Allium for details',
  import_feature_contents: 'Import Logic from another Feature',
  importing_feature_contents_to: 'Import Logic to Feature',
  exit_import_logic: 'Exit Import Logic',
  import_logic: 'Import Logic',
  import_feature: 'Import Feature',
  imported_feature: 'Imported Feature',
  confirm_selection: 'Confirm Selection',
  confirm_import: 'Confirm import',
  import: 'Import',
  object_type: 'Object Type',
  orphan_queries: 'Orphan Queries',
  orphan: 'Orphan',
  carried_by: 'Carried by',
  select_plant: 'Select Plant Location',
  show_with_custom_layouts: 'Only Show Vehicles With Custom Layouts',
  serial: 'Serial',
  customer: 'Customer',
  product_description: 'Product Description',
  location_not_selected: 'Select a Plant Location to See Results',
  error_description: 'Error Description',
  days_out: 'Days Out',
  select_product_description: 'Select Product Description',
  select_error_description: 'Select Error Description',
  select_customer: 'Select Customer',
  select_Modal: 'Select Model',
  enter_serial: 'Enter Serial',
  upcoming_builds: 'Upcoming Builds',
  use_this_location_as_default: 'Use This Location As Default',
  reset_filters: 'Reset Filters',
  production_schedule: 'Production Schedule',
  previous_vehicle: 'Previous Vehicle',
  next_vehicle: 'Next Vehicle',
  search_feature: 'Search feature',
  engine_speed_settings: 'Engine Speed Settings',
  fixed_speed: 'FIXED SPEED',
  speed_control_limits: 'SPEED CONTROL LIMITS',
  steering_wheel_speed_settings: 'STEERING WHEEL SPEED SETTINGS',
  these_settings_are_relavant_for_all_pto:
    'These settings are relevant for all PTO',
  speed_control_mode: 'Speed Control Mode: 32',
  minimum: 'MINIMUM',
  maximum: 'MAXIMUM',
  unconnected_switch_signals: 'Unconnected Switch Signals',
  the_following_signals_require_a_selected_part:
    'The following signals require a selected part',
  require_a_selection_of_a_part_number: (serialNumber) =>
    `Feature(s) requires a selection of a part number when adding to vehicle ${serialNumber}`,
  select_switchs: 'Select Switches',
  select_a_switch_to_connect_to_the_signals:
    'Select a Switch to Connect to the Signals',
  // PBI 147363 - Documentation 4: New header for switch selection modal
  select_switches_to_use_with_new_features: (serialNumber) =>
    `Select switches to use with the new Features on ${serialNumber}`,
  signal_requires_switch: 'Signal Requires a Switch',
  switch_selected: 'Switch Selected',
  select_switch: 'Select Switch',
  par_file_download_success: (serialNumber) =>
    `A single compressed zip file has been downloaded to your computer named ${serialNumber}.zip.`,
  par_error_download_fail: '.PAR files could not be downloaded due to errors.',
  download: 'Download',
  par_error_main_header: 'Error creating a .PAR file',
  par_file_error_modal_header:
    '.PAR files that cannot be dowloaded due to errors',
  par_file_no_error_modal_header: '.PAR files that can be downloaded',
  par_file_modal_chec_contact:
    'Please reconfigure your logic or contact CHEC support at checsupport@daimlertruck.com',
  par_file_modal_footer_download_message:
    'Download the .PAR files without errors to a single compressed zip file.',
  par_file_modal_footer_no_download_message:
    '.PAR files could not be downloaded due to errors.',
  par_file_modal_footer_remaining_download_message:
    'Download the remaining eligible files.',
  par_file_modal_validation_explanation:
    'Validation results are shown below. Entries marked not generated are not included for this request.',
  par_file_modal_blocked_module: (moduleLabel) => `${moduleLabel} — blocked`,
  par_file_modal_no_validation_error: (moduleLabel) =>
    `${moduleLabel} — no validation error reported`,
  sg_notes_warning_description:
    'Custom switch graphics are not loading due to bad line notes. Check the line notes for modules 4CG and 4CH.',
  engine_speed_setting_error:
    'This vehicle does not have a diagnostic variant; engine speed settings are not available.',
  custom_switch_notes_error: ' Bad Line Note Format',
  settings_changed: <strong>Settings Changed:</strong>,
  batteryVoltage_title: () => <strong>Proper battery voltage required</strong>,
  batteryVoltage_description:
    'Use a battery tender on the vehicle during programming and testing.',
  connectDiagnostic_title: (isSSAM) => (
    <strong>
      {`Establish connections in DiagnosticLink and program ${
        isSSAM ? 'SSAM' : 'ECP'
      }`}
    </strong>
  ),
  connection_description:
    'Open DiagnosticLink, connect to the vehicle controllers, and then connect DiagnosticLink to the server.',
  SSAM_title: (isSSAM) => (
    <strong>
      {`Program the ${isSSAM ? 'SSAM' : 'ECP'} in DiagnosticLink`}
    </strong>
  ),
  SSAM_description: (isSSAM) =>
    `Program the ${
      isSSAM ? 'SSAM' : 'ECP'
    } in the Program Device tab with the desired "Newest or Latest" + "CHEC" configuration. ` +
    'Connect DiagnosticLink to the server to send confirmation to CHEC.',
  return_chec_title: <strong>Return to CHEC to make any changes</strong>,
  returnChec_description:
    'Use the Compare Parameters tab in DiagnosticLink to verify parameter level changes.' +
    'Test Features and repeat steps 1 & 2 for changes.',
  all_signals_must_be_connected_to_a_switch_to_proceed:
    'All signals must be connected to a switch to proceed.',
  change_switch: 'Change Switch',
  pto_alert_header: (pendingCount, pending_updates) =>
    `${pending_updates} (${pendingCount})`,
  email_us: 'Contact us',
  select_settings_type: 'Select Setting Type',
  source_vehicle_error_text: 'This is the source vehicle.',
  select_which_settings_should_be_copied_from_source_vehicle_m2: (
    serialNumber
  ) =>
    `Select which settings should be copied from the source vehicle (${serialNumber}) to the fleet.`,
  commit_settins_to_fleet_m2: (settingsView) =>
    `Commit ${settingsView} Settings to Fleet`,
  select_which_settings_should_be_copied_from_source_vehicle: (serialNumber) =>
    `Select which vehicles should have their settings updated to match ${serialNumber} (source vehicle).`,
  commit_settins_to_fleet: (setting) => `Commit Settings to Fleet: ${setting}`,
  dignostic_variants_must_match_prior_to_fleet_update:
    'Diagnostic variants must match prior to fleet update',
  quick_fit_logic_and_pto: 'QuickFit Logic & PTO',
  quick_fit_logic: 'QuickFit Logic',

  rp_collections_incomp_subtype: 'Incompatible',
  admin_alert_text: <strong>Admin Alert:</strong>,
  info_alert_text: <strong>Information: </strong>,
  warning_alert_text: <strong>Warning: </strong>,
  success_alert_text: <strong>Success: </strong>,
  error_alert_text: <strong>Error: </strong>,
  create_template_alert_text:
    'This template will only be applicable to vehicles with similar engine and transmission configurations.',
  create_template_choose_domains:
    'Choose domain(s) to add to your new PTO Template',
  create_template_add_description: 'Add a description',
  save_pto_template: 'Save PTO Template',
  new_pto_template_drawer_title: 'New PTO Template',
  pto_template_tooltip:
    'Save your current configuration as a template for reuse on other vehicles.',
  pto_template_disabled_unsaved_changes:
    'Save or reset your PTO changes before applying a template.',
  pto_value_to_template: 'Value to Template',
  pto_conflict_setting: 'Setting Conflict',
  pto_template_values_out_of_range_header: 'Some PTO values are out of range',
  pto_save_template_content_pre:
    'You can apply one of the following options to your template:',
  pto_save_template_content_list: [
    'Update these settings, rounded to permissible values',
    'Delete all settings that are outside of the recommended range',
  ],
  pto_use_rounded_settings: 'Use Rounded Settings',
  pto_del_invalid_settings: 'Delete Invalid Settings',
  pto_fragment_range_rounded: 'ROUNDED',
  pto_fragment_out_of_range_no_valid: 'Not a valid state',
  pto_fragment_recommended_range: (min, max, units) =>
    `Out of range (recommended: ${min}-${max} ${units.toUpperCase()})`,
  pto_fragment_recommended_bool_range: (isOff) =>
    `Incorrect state (recommended: ${isOff ? 'Off' : 'On'})`,
  pto_template_skipped_fragments: 'Skipped Fragments:',
  pto_template_updated_fragments: 'Update the Following',
  pto_template_name_title: 'Template Name',
  pto_template_name_description: 'Template Description',
  pto_template_name_placeholder: 'Enter template name',
  apply_pto_template_no_fragments: 'This domain doesn\u2019t contain fragments',
  apply_pto_template_no_templates:
    'Your search returned no results. Please check your spelling or try a different search term.',
  select_pto_template_mode_title:
    'Which type of PTO Template would you like to use?',
  apply_pto_template_replace_vehicle_pto_configuration:
    "Applying a PTO Template to a vehicle will replace the vehicle's current PTO configuration.",
  select_pto_template_mode_daimler: 'Pre-Defined Templates',
  select_pto_template_mode_custom: 'Custom Templates',
  select_pto_template_mode_create_new: 'Create a New Template',
  pto_template_view_details: <>View Details&nbsp;&nbsp;</>,
  pto_template_out_of_range_text:
    'Some settings are outside the recommended value range',
  apply_pto_title_daimler: 'Select Daimler PTO Template',
  apply_pto_title_custom: 'Select Custom PTO Template',
  pto_template_save_success: (templateName) =>
    `Success: ${templateName} has been saved`,
  pto_template_save_fail: (templateName) =>
    `Error: ${templateName} has not been saved`,
  pto_template_update_failed: (
    <strong>
      Something went wrong and CHEC was unable to save your changes. Please try
      again. To contact CHEC support, please submit a{' '}
      <a
        href={DTNA_CASE_MANAGEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        DTTS/ Salesforce
      </a>{' '}
      case
    </strong>
  ),
  pto_template_update_succeeded: 'Your PTO template was successfully updated',
  replace_switch_graphic: 'Replace Switch Graphic',
  replace_tem_indicator_graphic: 'Replace TEM Indicator Graphic',
  custom_switch_graphics: 'Custom Switch Graphics',
  custom_indicator_graphics: 'Custom Indicator Graphics',
  custom_tem_indicator_graphics: 'Custom TEM Indicator Graphics',
  // S&G Replace Switch with Shared Signal (PBI 147363)
  would_you_like_different_switch:
    'Would you like to use a different switch with this input?',
  select_replacement_switch: 'Select a replacement switch',
  no_alternative_switches_available: 'No alternative switches available',
  replace_switch: 'Replace Switch',
  switch_replaced_successfully: 'Switch replaced successfully',
  replacing_switch: 'Replacing switch...',
  alternative_switches: 'Alternative Switches',
  current_switch: 'Current Switch',
  signal: 'Signal',
  // Contextual Help Accordion (PBI 147363)
  would_you_like_to_swap_smart_switch:
    'Would you like to use a different switch with this input?',
  several_smart_switches_can_use_logic_input:
    'This Logic Input is shared by other Smart Switches. You can replace the current switch with another compatible option.',
  update_switch: 'Update Switch',
  // PBI 147363 - Documentation 9: Update Switches Large Modal
  update_switches_to_use_on: (serialNumber) =>
    `Update switches to use on ${serialNumber}`,
  switch_already_on_dash:
    'This switch is currently on the dash and cannot be selected',
  // Switch Selection Needed Modal (PBI 147363)
  switch_selections_needed: 'Switch selection(s) needed',
  at_least_one_feature_needs_switch:
    'At least one new Feature needs to be connected to a switch for use on the vehicle:',
  has_1_unconnected_switch_signal: 'has 1 unconnected switch signal.',
  has_n_unconnected_switch_signals: (count) =>
    `has ${count} unconnected switch signals.`,
  select_switches: 'Select Switches',
  enter_cap_part_number_or_title: 'Enter cap part number or title',
  select_graphic: 'Select a Graphic',
  create_collection_success: (title) => `Success: "${title}" has been saved.`,
  view_collection: 'View Collection',
  no_collections_found: 'No collections found',
  removing_the_following_cap_graphics: 'Removing the following cap graphic',
  added_the_following_cap_graphic: 'Adding the following cap graphic',
  you_dont_have_the_necessary_authorization_to_use_chec_dash:
    'You don’t have the necessary authorization to use CHEC Dash',
  please_make_sure_you_have_the_appropriate_certificate_to_continue:
    'Please make sure you have the appropriate certification to continue.',
  go_to_chec_homepage: 'Go to CHEC Homepage',
  unassigned_part: 'Unassigned Part',
  unassigned_condition: 'Unassigned',
  your_search_returned_no_results:
    'Your search returned no results. Please check your spelling or try a different search term',
  please_enter_a_cap_number_or_title_to_see_results:
    'Please enter a cap number or title to see results.',
  this_vehicle_is_not_supported_by_chec:
    'This vehicle is not supported by CHEC.',
  search_results: 'Search Results',
  this_vehicle_was_not_found_in_the_chec_database:
    'This vehicle was not found in the CHEC database.',
  line_notes_invalid_search:
    'The following line notes do not match any switch configurations:',
  chec_bhm_chec_ceeap_certification_required_to_modify_this_vehicle:
    'CHEC-BHM and CHEC-CEEA+ certifications as required to view and modify these vehicles.',
  please_visit_dtnaarc_to_review_your_certificate: (() => {
    const $link = (
      <a
        style={{ color: '#0051c4', margin: '0 4px' }}
        href="https://dtnaarc.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        dtnaarc.com
      </a>
    )
    return (
      <>
        <React.Fragment key="please">Please visit</React.Fragment>
        <React.Fragment key="follow">{$link}</React.Fragment>
        <React.Fragment key="link">
          to review your certification.
        </React.Fragment>
      </>
    )
  })(),
  not_compatible_with_the_vehicle: 'Not compatible with the vehicle',
  not_supported_by_chec: 'Not supported by CHEC',
  rp_is_obsolete: 'RP is obsolete',
  add_collection_to_vehicle: 'Add Collection to Vehicle',
  collection_is_not_compatible:
    'This collection contains one or more RPs that are incompatible with the vehicle.',
  collection_is_not_compatible_with_features:
    'This collection contains one or more Features that are incompatible with the vehicle.',
  // PBI 150666: Status-based incompatibility message for vehicle selection
  collection_status_not_active:
    'Only collections with the status "Active" may be added to a vehicle.',
  back_to_rps: 'Back to RPs',
  back_to_collections: 'Back to Collections',
  circuits_require_mapping: (length, serialNumber) =>
    `RP${
      length === 1 ? '' : 's'
    } require circuit mapping to vehicle ${serialNumber}`,
  select_location_details_and_type: 'Select location details and type',
  change_location_detail_and_type: 'Change location detail and type',
  requires_location_and_detail_type_to_place_on_a_panel:
    'requires location and detail type to place on a panel',
  search_using_location_type_description:
    'Search using location type description',
  unknown_location: 'Unkown location',
  no_location_for: 'No location for:',
  location_detail_and_type_have_been_updated:
    'Location detail and type have been updated, this part can now be placed on the dash.',
  the_part_must_be_placed_on_the_dash_to_save_changes_to_its_location_and_type:
    'The part must be placed on the dash to save changes to its location and type.',
  chec_bhm_certification_required_to_modify_this_vehicle:
    'CHEC-BHM certification is required to modify this vehicle.',
  chec_ceeap_certification_required_to_modify_this_vehicle:
    'CHEC-CEEA+ certification is required to modify this vehicle.',
  illustration_represents_standard_configuration:
    'Illustration represents standard configuration',
  bhm_pins: 'BHM Pins',
  m_logic: 'MLogic',
  rps: 'RPs',
  chm_pins: 'CHM Pins',
  exm1_pins: 'EXM 1 Pins',
  exm2_pins: 'EXM 2 Pins',
  smart_plex: 'SmartPlex',
  on_vehicle: 'On Vehicle',
  model: 'Model',
  data_translator: 'Data Translator',
  chec: 'CHEC',
  chec_main_title: 'CHEC, Build it fast. Build it right.',
  variant: 'Variant',
  module_label: 'Module',
  fragments: 'Fragments',
  part_numbers: 'Part Numbers',
  fragment_name: 'Fragment Name',
  fragment: 'Fragment',
  physical_value: 'Physical Value',
  encoded_value: 'Encoded Value',
  default: 'Default',
  domain_part_number: 'Domain Part Number',
  default_value: 'Default Value',
  select_variant: 'Select Variant',
  bhm_limited_module:
    'The BHM controller on this vehicle has reduced available pins. Please contact CHEC support if you have any questions.',
  chm_limited_module:
    'The CHM controller on this vehicle has reduced available pins. Please contact CHEC support if you have any questions.',
  bhm_chm_limited_module:
    'The BHM and CHM controllers on this vehicle have reduced available pins. Please contact CHEC support if you have any questions.',
  contact_for_questions:
    'Please contact CHEC support if you have any questions.',
  role_read_only_bhm: 'Tier 0 BHM',
  role_read_only_plus: 'Tier 0 CEEA+',
  notifications: 'Notifications',
  admin_alert: 'Admin Alert',
  this_module_version_does_not_include_a_pin_in_this_location:
    'This module version does not include a pin in this location.',
  list_view: 'List View',
  back_to_list_view: 'Back to List View (editable)',
  return_to_list_view: 'To edit part locations, return to',
  show_details: 'Show details',
  hide_details: 'Hide Details',
  parts_cannot_be_moved_when_viewing_table:
    'Parts cannot be moved when viewing table',
  read_only: 'Read-only',
  removing_as_built_features: 'Removing the following factory-defined Features',
  removing_as_built_features_notification:
    "You are about to remove Feature content that is part of the vehicle's factory specification.",
  add_xmc: 'Add XMC',
  add_xmc_to_vehicle: 'Add XMC to Vehicle',
  xmc_modules: 'ECUs on Vehicle',
  add_xmc_btn: 'Add XMC',
  add_xmc_warning_msg:
    'Any additional XMCs added to this vehicle cannot be removed from CHEC after saving.',
  add_to_vehicle_btn: '+ Add to Vehicle',
  add_xmc_error_default: 'Something went wrong',
  add_xmc_success_message: (lastXMCName) =>
    lastXMCName
      ? ` and ${lastXMCName} were added to vehicle`
      : ' is added to vehicle',
  add_xmc_warning_message_on_success:
    'Ensure that any XMC added to CHEC is installed on the vehicle',
  select_module: 'Select Module',
  please_select_a_plant_location_to_see_results:
    'Select a Plant Location to See Results',
  retry: 'Retry',
  production_schedule_could_not_be_loaded:
    'This page of the Production Schedule could not be loaded.',
  production_schedule_page_not_loaded: 'This page could not be loaded.',
  expanded_summary_view: 'Expanded Summary View',
  used: 'used',
  lower_panel: 'Lower Panel',
  removing_the_features: 'Removing the Features',
  resolve_conflicts: 'Resolve Conflicts',
  back_to_features: 'Back to Features',
  new_features_have_conflicts_with_features_already_on_the_vehicle:
    'New Features have conflicts with Features already on the vehicle.',
  digital_input_conflicts: 'Digital Input Conflicts',
  analog_input_conflicts: 'Analog Input Conflicts',
  digital_output_conflicts: 'Digital Output Conflicts',
  can_output_conflicts: '16-Bit CAN Output Conflicts',
  switches_with_shared_signals: 'Switches with Shared Signals',
  review_features: 'Review Features',
  features_cannot_be_added:
    'Features cannot be added to the vehicle without resolving all conflicts.',
  add_features: 'Add Features',
  digital_input_configuration_conflicts:
    'Digital Input Configuration Conflicts',
  analog_input_configuration_conflicts: 'Analog Input Configuration Conflicts',
  features_conflict_digital_input:
    'New Features have digital input configuration conflicts with Features on the vehicle.',
  features_conflict_analog_input:
    'New Features have analog input configuration conflicts with Features on the vehicle.',
  features_conflict_digital_output:
    'New Features have digital output configuration conflicts with Features on the vehicle.',
  features_conflict_can_output:
    'New Features have 16-bit CAN output message conflicts with Features already on the vehicle.',
  // Collection-specific variants of the above conflict description strings
  new_features_have_conflicts_with_features_already_in_collection:
    'New Features have conflicts with Features already in the Feature Collection.',
  features_conflict_digital_input_collection:
    'New Features have digital input configuration conflicts with Features already in this collection.',
  features_conflict_analog_input_collection:
    'New Features have analog input configuration conflicts with Features already in this collection.',
  features_conflict_digital_output_collection:
    'New Features have digital output configuration conflicts with Features already in this collection.',
  features_conflict_can_output_collection:
    'New Features have 16-bit CAN output message conflicts with Features already in this collection.',
  in_collection: 'In Collection',
  what_is_in_collection: 'Currently in the collection.',
  new_feature_pending_collection: 'Pending commit to collection.',
  collection_conflicts_must_be_resolved:
    'All conflicts must be resolved before features can be added to the collection.',
  select_which_configuration_digital_input:
    'Select which configuration you want to use for Digital Input',
  select_which_configuration_analog_input:
    'Select which configuration you want to use for Analog Input',
  select_which_configuration_digital_output:
    'Select which configuration you want to use for Digital Output',
  select_which_configuration_can_output: ({
    module,
    canId,
    startBit,
    numberOfBits,
  }) =>
    `Select which Feature you want to control ${module}, CAN ID ${canId} (bit/byte block: Byte 0, Bit ${startBit} - Byte 1, Bit ${numberOfBits})`,
  remaining_digital_input_conflicts: 'Remaining Digital Input Conflicts',
  remaining_analog_input_conflicts: 'Remaining Analog Input Conflicts',
  remaining_digital_output_conflicts: 'Remaining Digital Output Conflicts',
  remaining_can_output_conflicts: 'Remaining CAN Output Conflicts',
  features_with: 'Features with',
  factory_defined: 'Factory-defined',
  factory_defined_on_vehicle: 'On vehicle (factory-defined)',
  active_low_polarity_selected_informational:
    'Selecting "Active Low" will remove all "Active High" features.',
  active_high_polarity_selected_informational:
    'Selecting "Active High" will remove all "Acitve Low" features.',
  selecting_this_configuration_will_remove:
    'Selecting this configuration will remove all conflicting features.',
  no_ecus_installed: "This vehicle doesn't have any ECU modules installed.",
  you_have_exceeded_the_max: (type, list) =>
    `You have exceeded the maximum number of ${type} allowed on ${list}. Remove Features that include ${type} to save your changes.`,
  qpm1: 'QPM 1',
  qpm2: 'QPM 2',
  qpm_tooltip_content:
    'XMC 3 and XMC 4 are also known as QPM 1 and QPM 2. QuickFit Programmable Modules (QPMs) are fully editable, and don’t contain factory-defined settings.',
  what_is_factory_defined: 'Part of the vehicles factory specification.',
  what_is_on_vehicle: 'Currently on the vehicle.',
  what_is_new_feature: 'Pending commit to vehicle.',
  new_feature: 'New Feature',
  add_individual_feature: 'Add Individual Feature',
  use_feature_collection: 'Use Feature Collection',
  feature_collection_search_sort_by: 'Sort by:',
  feature_collection_search_sort_label_newest_first: 'Newest first',
  feature_collection_search_sort_label_oldest_first: 'Oldest first',
  feature_collection_search_sort_label_title_asc: 'Title (A to Z)',
  feature_collection_search_sort_label_title_desc: 'Title (Z to A)',
  empty_feature_collections:
    'Your search returned no results. Please check your spelling or try a different search term.',
  module_feature_is_restricted: (moduleName) =>
    `${moduleName} module features can not be added to a collection`,
  feature_status_cannot_be_added: (status) =>
    `"${status}" Features can not be added to a collection`,
  conflict_description: 'Conflict Description',
  collections_can_be_used_to_quickly:
    'Collections can be used to quickly apply Features to other vehicles',
  features_marked_for_removal_cannot_be_added_to_a_collection:
    'Features marked for removal can not be added to a collection',
  make_a_new_collection_from_the_following_features_on: (serialNumber) =>
    `Make a new Collection from the following Features on ${serialNumber}`,
  only_xmc_3_and_xmc_4_features_notification:
    'Only XMC 3 and XMC 4 Features in "Active" status can be used in a collection.',
  lp017_and_lp018: 'LP017 & LP018',
  add_msf: 'Add MSF',
  add_msf_to: 'Add MSF to',
  msf_location_warning: 'May interfere with dash structure',
  add_remove_msfs: 'Add/Remove MSFs',
  remove_msf: 'Remove MSF',
  add_remove_msfs_body:
    'You can add or remove MSFs on the dash of this vehicle.',
  adding_msfs_header: 'Adding MSFs:',
  adding_msfs_body:
    'MSFs can be added to empty locations on the dash or replace a storage pocket. If an MSF replaces a storage pocket, that part will be permanently removed from CHEC.',
  removing_msfs_header: 'Removing MSFs:',
  removing_msfs_body:
    'MSFs that were added to the vehicle after it left the factory can be removed in CHEC. Any switches that have been placed in the MSF will also be removed.',
  no_aftermarket_msf_locations_available:
    'No aftermarket MSF locations are available.',
  overhead_pocket_cannot_accept_msf:
    'Cannot add MSFs to an overhead storage pocket.',
  no_aftermarket_msfs_added: 'No aftermarket MSFs have been added.',
  you_are_about_to_add_an_msf_to_dash:
    'You are about to add an MSF to the dash',
  continue: 'Continue',
  add_msf_para_1:
    'MSFs can be added to empty locations on the dash or replace a storage pocket. If an MSF replaces a storage pocket, that part will be permanently removed from CHEC.',
  add_msf_para_2: 'Are you sure you want to add an MSF to this location?',
  this_panel_does_not_have_any_available_msf_locations:
    "This panel doesn't have any available MSF locations.",
  collection_can_not_be_added:
    'Features can not be added to the collection without resolving all conflicts.',
  vehicle_collection_conflicts_must_be_resolved:
    'All conflicts must be resolved before the collection can be applied to the vehicle.',
  add_ecp: 'Add ECP',
  add_ecp_min_solenoid_msg:
    'At least one (1) solenoid is required to save the new ECP.',
  ecp_added: 'ECP Added:',
  add_ecp_warning:
    'Any additional ECPs added to this vehicle cannot be removed from CHEC after saving',
  feedback_or_questions:
    'If you have feedback, questions, or comments related to the CHEC tool, please send them to:',
  panel_number_not_found:
    'CHEC does not recognize this part number or could not find it on the dash of the vehicle. You can check the number for errors or try a different part number.',
  search_for_result: 'Search results for',
  part_number_search_tooltip:
    "Scan a QR code or enter a part number to find any valid switch for this vehicle's dash.",
  enter_part_number: 'Enter part number',
  help_and_documentation: 'Help & Documentation',
  warning_2a_pin:
    'This 2A output pin is routed through the VPDM. Outputs from this pin are converted to 20A at the Interface Connector.',
  warning_20a_pin_43N:
    'This 2A output pin is routed through the VPDM. Outputs from this pin are converted to 20A.',
  warning_2a_pin_virtual_fusing:
    'This 20A output is routed through the VPDM. This output does not support Virtual Fusing.',
  help_tootltip_pin_interface:
    'This pin is not routed through the Interface Connector. You will need to add a circuit to this pin on the ECU.',
  add_feature_2a_output: (dbCode = '35M-011') =>
    `Features with 2A output pins configured as PWM or Active Low cannot be added if those pins are used as relay drivers for vehicles with the QuickFit Sales Code ${dbCode}.`,
  add_feature_features_table_2a_output: `This Feature's 2A output pin is routed through the VPDM. Outputs from this pin are converted to 20A at the Interface Connector.`,
  add_feature_features_table_20a_output:
    "This Feature's 20A output is routed through the VPDM. This output does not support Virtual Fusing.",
  lower_storage_pocket_one: 'Lower Storage Pocket 1',
  lower_storage_pocket_two: 'Lower Storage Pocket 2',
  left_storage_pocket: 'Left Storage Pocket',
  right_storage_pocket: 'Right Storage Pocket',
  center_storage_pocket: 'Center Storage Pocket',
  ecu_information_gap_warning:
    'ASAM, XMC 1, and XMC 2 pins are reserved for factory-defined content and data is for reference only. Please contact CHEC support if you have any questions.',
  scan_code: 'Scan Code',
  print_dash: 'Print Dash',
  scan_a_qr_code_now: 'Scan a QR Code Now',
  scan_the_qr_code_on_the_switch:
    "Scan the QR code on the switch to find it on the vehicle's dash.",
  part_without_location_info_tooltip:
    'Parts that are not on your dash are placed here. You can place components here while you organize the dash layout.',
  put_part_in_staging_area_message:
    'You can put this part in the Staging Area. Move it to the “Parts without locations” section of the side panel while you organize the dash layout.',
  move_to_the_staging_area: 'Move to the Staging Area',
  msf: 'MSF',
  staging_area: 'Staging Area',
  these_parts_require_placement: 'These parts require placement',
  staging_location_warning_info:
    'This part has been moved to the Staging Area. It must be placed on the dash before you can save your changes.',
  not_allowed_to_put_on_staging_message:
    'This part only has one location on the dash. It cannot be placed in the Staging Area.',
  saving_dash_error:
    'All parts in the Staging Area must be placed on the dash before you can save.',
  staging_location_info_message:
    'Parts moved off of the dash are accessible here. These parts must be placed on the dash before your changes can be saved.',
  selecting_this_output_configuration_will_remove:
    'Selecting this will remove all Features with different configurations.',
  logic_signal: 'Logic Signal',
  no_remaining_conflicts: 'No Remaining Conflicts',
  pre_prod_warning_lead:
    'This lead vehicle is in pre-production. Only Switch & Gauge settings can be modified.',
  cant_find_what_looking_for: "Can't find what you're looking for",
  what_chec_can_do: 'What CHEC Can Do',
  an_output_pin_can_be_associated_with_multiple_features_if:
    'An output pin can be associated with multiple Features if:',
  feature_configuration_details: () => (
    <>
      <li>All Features share a common configuration</li>
      <li>None of these Features are utilizing PWM polarities.</li>
    </>
  ),
  digital_output_pin: 'Digital Output Pin',
  an_output_pin_with_a_pwm_polarity_config_can_only_have_one_feature_associated_with:
    'An output pin with a PWM polarity configuration can only have one (1) Feature associated with it',
  select_a_configuration: 'Select a configuration',
  not_found_qr:
    'This QR code may be invalid or damaged. You can scan the code again or enter the part number manually. You also can try a different switch part number.',
  qr_time_out:
    'CHEC did not receive a QR code. You can scan the code again or try manually entering the switch part number.',
  switch_search_time_out: 'Switch search timed out',
  associated_features: 'Associated Features',
  remove_of_keep_blurb: (serialNumber) =>
    `These switches are associated with Features you are removing from ${serialNumber} and can also be removed from the dash. Select any switches you want to remove from the vehicle.`,
  you_are_about_to_commit_changes_to_vehicle: (serialNumber) =>
    `You are about to commit changes to vehicle ${serialNumber}`,
  keep_switches_on: (serialNumber) => `Keep Switches on ${serialNumber}?`,
  add_switch_back: 'Add switch back',
  vehicle_is_unavailable_as_source: (
    <div style={{ width: '400px', paddingRight: '20px' }}>
      <p>Why can&apos;t I apply Features to my fleet?</p>
      <p>For XMC 3-8:</p>
      <ol>
        <li>Are all Features on the source vehicle in the Active state?</li>
        <li>Does the source vehicle have Features applied by CHEC?</li>
      </ol>
    </div>
  ),
  checking_for_conflicts: 'Checking for Conflicts',
  you_are_viewing_chec_read_only_bhm:
    'You are viewing CHEC in read-only mode. CHEC-BHM certification is required to create or modify custom logic.',
  you_are_viewing_chec_read_only_ceea:
    'You are viewing CHEC in read-only mode. CHEC-CEEA+ certification is required to create or modify custom logic.',
  please_select_source_vehicle_which_has:
    'Please select a source vehicle which has had features applied to XMC 3 and/or 4 through CHEC',
  all_xmc_3_and_4_features_must_be:
    'All XMC 3 and/or 4 features must be activated before this vehicle can be used as a source.',
  component_errors: 'Component Errors',
  parts_with_errors_message:
    'Parts with errors are placed here. Errors need to be resolved to place these parts on the dash.',
  fleet_management_msf_error:
    'This vehicle has dash parts that cannot be removed.',
  fleet_management_msf_and_ecp_error:
    'This vehicle has dash parts and additional ECPs that cannot be removed.',
  fleet_management_ecp_error:
    'This vehicle has additional ECPs that cannot be removed.',
  fleet_management_xmc_error:
    'This vehicle has a different XMC inventory than the source vehicle.',
  fleet_management_source_error: 'This is the source vehicle.',
  confirm_selected_switches: 'Confirm Selected Switches',
  enum_values: 'Enum Values',
  contextual_help_change_status_of_feature:
    'Because you’ve changed the status of this Feature before:',
  contextual_help_changes_to_this_feature: (
    <>
      <p>
        You have made changes to this Feature. These changes will not be
        automatically updated on vehicles that use it.
      </p>
      <p>Do you want to go to a vehicle and apply your changes?</p>
    </>
  ),
  lets_go: 'Let’s Go',
  enter_a_serial_number_dot_dot_dot: 'Enter a serial number...',
  changes_to_this_feature_have_been_saved:
    'Changes to this Feature have been saved',
  obsolete_feature_alert_tooltip: `CHEC recommends that you replace or remove "Obsolete" Features.`,
  obsolete_feature_collection_edit_tooltip: `Only Features with status "Active" may be added to a collection. CHEC recommends that you replace or remove "Obsolete" Features.`,
  obsolete_feature_checkbox_tooltip: `Only Features with status "Test" or "Active" may be added to a vehicle.`,
  changes_to_this_feature_status_as_obsolete_saved: `This Feature's status is "Obsolete." It cannot be added to a vehicle. You can either duplicate it or import its logic into another Feature.`,
  vehicle_contains_obsolete_features:
    'The status of at least one Feature used on this vehicle is "Obsolete". CHEC recommends that you replace or remove "Obsolete" Features.',
  update_features: 'Update Features',
  manually_update_solenoids: 'Manually Update Solenoids',
  update_to_the_newer_version_recommended:
    'Update to the newer version (recommended)',
  keep_using_this_version: 'Keep using this version',
  remove_this_feature: 'Remove this Feature',
  cannot_add_feature_to_native_switch:
    'This switch is reserved for factory-defined content. It is not eligible for custom logic.',
  find_factory_interface_connector_helper:
    'Find where this pin is located on your vehicle:',
  analog_input_interface_connector_helper:
    'Because you’re using an Analog Input Pin',
  analog_input_interface_connector_helper_title:
    'This Feature has associated pins',
  analog_input_interface_connector_helper_text:
    'Analog Input Feedback Pins need to be manually connected at the XMC. For this input to function properly, the Reference Pin associated with this Feedback Pin also needs to be connected.',
  find_factory_interface_connector: (
    location
  ) => `To find the factory defined Interface Location for ${location}, select a
        vehicle type and QuickFit Sales Code`,
  vpdm_warning:
    'This output pin is routed through the VPDM. Outputs from this pin are converted to 20A.',
  add_vehicle_comment_placeholder: 'Add a Vehicle Summary note',
  save_comment: 'Save Note',
  comments_sort_by_newest_first: 'Newest First',
  comments_sort_by_oldest_first: 'Oldest First',
  comment_posted_time_string: (elapsed) => {
    if (elapsed.time > 1) {
      return `${elapsed.time} ${elapsed.unit}s ago`
    }

    if (elapsed.time === 1) {
      return `${elapsed.time} ${elapsed.unit} ago`
    }

    return `just now`
  },
  comments_tooltip: 'Notes are only available on the Vehicle Summary page',
  no_fragments_part_numbers_info:
    'No fragments or part numbers are associated with this domain.',
  vehicle_is_not_part_of_a_fleet: 'Vehicle is not part of a fleet',
  collections_can_be_used_to_quickly_apply_multiple_featues:
    'Collections can be used to quickly apply multiple Features to the vehicle.',
  // Fast Features
  ff_fast_features: 'Fast Features',
  contextual_help_change_feature_output:
    'Because you’ve selected a TEM Custom Switch Input:',
  contextual_help_changes_to_this_output:
    'Do you want to add an Output that uses the following switch indicator:',
  no_thanks: 'No Thanks',
  results_with_search_string_and_total: (searchString, total) =>
    `Search results for “${searchString}” (${total})`,
  feature_number: 'Feature No',
  qpm_modules_title: 'QuickFit Programmable Modules',
  qpm_modules_subtitle: (code) =>
    code ? (
      <span>
        XMC 3 and XMC 4 (configured by QuickFit Sales Code{' '}
        <strong>{code}</strong>) are also known as QPMs. QuickFit Programmable
        Modules (QPMs) are fully editable and don&apos;t contain factory-defined
        settings.
      </span>
    ) : (
      "XMC 3 and XMC 4 are also known as QPMs. QuickFit Programmable Modules (QPMs) are fully editable and don't contain factory-defined settings."
    ),
  school_bus_modules_title: 'School Bus Programmable Modules',
  school_bus_modules_subtitle:
    'XMC 3 through XMC 8 are fully editable modules.',
  factory_modules_title: 'Factory-Controlled Modules',
  factory_modules_subtitle: (
    <p>
      ASAM, XMC 1, and XMC 2 Features are reserved for factory-defined content.
      Data is presented only for reference. Only DTNA Tier 3 users and Admins
      are permitted to modify these Features. If you have questions regarding
      factory-defined content, please{' '}
      <a
        href={DTNA_CASE_MANAGEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Create a DTTS/Salesforce case
      </a>{' '}
      related to CAC.
    </p>
  ),
  no_modules_text: (isQPM) =>
    `No ${isQPM ? 'programmable' : 'factory'} modules on this vehicle`,
  xmc_available_tooltip:
    'Additional QuickFit Programmable Modules may be available for this vehicle. Contact the application team to request an evaluation.',
  please_select_a_module_and_variant_to_see_domains:
    'Please select a module and variant to see domains.',
  custom_switch: 'Custom Switch',
  custom_tem_indicator: 'Custom TEM Indicator',
  dynamic_feature_tooltip_text: `CHEC-made Dynamic Features are a combination of Features that control the same output(s). Click here to view this Dynamic Feature’s outputs.`,
  dynamic_feature_tooltip_text_add_remove_features:
    'Features controlling the same output(s) must be removed to delete this CHEC-made Dynamic Feature.',
  error_reporting: 'Error Reporting',
  fast_feature_error_reporting: 'Fast Feature Error Reporting',
  fast_feature_error_reporting_instruction:
    'Select a processing date to view Fast Feature automation errors for that day.',
  fast_feature_error_forbidden:
    'You do not have permission to view this page. PlusAdmin role is required.',
  fast_feature_error_invalid_date:
    'Invalid date format. Please select a valid date.',
  fast_feature_error_generic:
    'An error occurred while fetching error reports. Please try again.',
  line_note_reader: 'Line Note Reader',
  line_note_reader_instruction:
    'Enter one or more switch codes to view the base and cap details for a custom switch. Multiple codes should be comma-separated.',
  cap_part_number: 'Cap Part Number',
  base_part_number: 'Base Part Number',
  base_description: 'Base Description',
  line_note: 'Line note',
  assigned_output: 'Assigned Output',
  custom_hardwired_switch_message:
    "The graphic for this Hardwired Switch (Custom Cap) is shown on an X-Series switch and may not match your vehicle's actual switch.",
  edit_this_location: 'Edit this location',
  preview: 'Preview',
  children: 'Children',
  edit_location: 'Edit location',
  information: 'Information',
  properties: 'Properties',
  edit_location_cancel:
    'You are about to abandon your proposed changes to this location. Are you sure you want to do this?',
  abandon_changes: 'Abandon Changes',
  continue_editing: 'Continue editing',
  continue_editing_feature: 'Continue Editing Feature',
  save_layout_location_cancel: 'No, Get Me Out Of Here',
  save_layout_location_confirm: 'Yes, Update It',
  save_layout_location_header: 'Update the following location',
  save_layout_location_text: (
    <>
      A location is about to be modified. The change will be applied to all
      vehicles that use the same dash type and modifier(s).
    </>
  ),
  this_location_has_been_updated: 'This location has been updated.',
  save_layout: 'Save Layout',
  updated_the_following: 'Updated the following',
  dash_layout: 'Dash Layout',
  dynamic_feature_validation_dialog_title: 'There are too many Logic Sets',
  dynamic_feature_validation_dialog_content: ({ serialNumber, data }) => {
    const totalAdded = data?.reduce(
      (sum, item) => sum + (item.currentLogicCount - item.maxLogicCount),
      0
    )
    return (
      <>
        <p>
          CHEC added <strong>{totalAdded}</strong>{' '}
          {totalAdded === 1 ? 'Logic Set' : 'Logic Sets'} to {serialNumber}{' '}
          because multiple Features control the same output. This exceeds the
          maximum Logic Sets allowed on the affected ECU.
        </p>
        <ul>
          {data?.map((item) => (
            <li key={`${item.module}-${item.currentLogicCount}`}>
              There are <strong>{item.currentLogicCount}</strong> Logic Sets on{' '}
              <strong>{item.moduleDisplayName}</strong> (maximum{' '}
              <strong>{item.maxLogicCount}</strong>)
            </li>
          ))}
        </ul>
        <p>To commit your changes to {serialNumber}, go back and remove:</p>
        <ul>
          {data?.map((item) => (
            <li key={item.module}>
              <strong>{item.currentLogicCount - item.maxLogicCount}</strong>{' '}
              Logic{' '}
              {item.currentLogicCount - item.maxLogicCount > 1 ? 'Sets' : 'Set'}{' '}
              from <strong>{item.moduleDisplayName}</strong>
            </li>
          ))}
        </ul>
        <p>This will require removing or editing Features.</p>
      </>
    )
  },
  child_locations: 'Child locations',
  edex_removed_switches:
    'These switches are being removed by DiagnosticLink. Add back any switches that you would like to keep on the vehicle.',
  refresh_the_page: <>Refresh the Page</>,
  uh_oh_thats_not_right: "Uh oh, that's not right",
  quickfit_sales_code: 'QuickFit Sales Code',
  quickfit_sales_code_help:
    'Your vehicle’s QuickFit Sales Code can be found on the ECUs tab.',
  refresh_feature_list: 'Refresh Feature list',
  refresh_rp_list: 'Refresh RP list',
  saving: 'Saving...',
  add_new_logic_set: 'New Logic Set',
  add_new_timer: 'New Timer',
  add_new_single_condition: 'New Single Condition',
  convert_to_a_single_condition: 'Convert to a Single Condition',
  this_logic_set_can_be_converted_into_a_single_condition:
    'This Logic Set can be converted to a Single Condition',
  convert: 'Convert',
  convert_to_a_logic_set: 'Convert to a Logic Set',
  this_single_condition_can_be_converted_to_a_logic_set:
    'This Single Condition can be converted to a Logic Set',
  convert_this_logic_set: 'Convert this Logic Set?',
  some_logic_set_variables_are_incompatible_with_single_condition:
    'Some of your Logic Set variables are not compatible with a Single Condition:',

  search_feature_collections: 'Search Feature Collections',
  something_went_wrong_while_trying_to_save_your_changes:
    'Something went wrong while trying to save your changes.',
  something_went_wrong_while_trying_to_update_a_location:
    'Something went wrong while trying to update a location.',
  native_inputs: 'Native Inputs',
  native_outputs: 'Native Outputs',
  cannot_add_feature_to_solenoid:
    'This solenoid is reserved for factory-defined content. It is not eligible for custom logic.',
  mate_to_part_no: 'Mate to Part No.',
  feature_control_solenoids_notification: (serialNumber) =>
    `New Features(s) controls solenoids that are not on the vehicle. Missing solenoid(s) will be automatically added to ${serialNumber}`,
  optional_solenoids_exceeding_limits: `New solenoids cannot be added by CHEC because they would exceed the vehicle's capacity.`,
  optional_solenoids_commit_view_title: 'Adding the following solenoids:',
  dynamic_feature_modal_title: (moduleName, type) =>
    `${moduleName}: Dynamic Feature Inventory, ${type} Outputs`,
  dynamic_feature_modal_body_text: `You can update a vehicle with Features that control the same Pin, Native, or 2-bit CAN Output.
  CHEC combines these Features into a temporary, vehicle-specific, Dynamic Feature.`,
  twoBitCan: '2-bit CAN',
  dynamic_feature_source_features_title: (featureNumber) =>
    `${featureNumber}: Source Features`,
  collection_no: 'Collection No',
  title: 'Title',
  created: 'Created',
  collection_type: 'Collection Type',
  collections_search_table_title: 'All Feature Collections',
  feature_collection_breadcrumb: 'Feature Collection Search',
  author: 'Author',
  creation_date: 'Creation Date',
  feature_collections_search_no_results_text: `Your search criteria returned no results. Please check your spelling, 
  try a different search term, or adjust your filter selections.`,
  feature_collections_dynamic_feature_tooltip_text:
    'CHEC-made Dynamic Features are a combination of Features that control the same output(s).',
  // Collection Lifecycle strings (PBI 150666)
  collection_status: 'Collection Status',
  feature_collection_status: 'Feature Collection Status',
  feature_collection_title: 'Feature Collection Title',
  collection_title_placeholder: 'Collection Title',
  activate_collection: 'Activate',
  confirm_activate_collection_header: 'Activate Feature Collection?',
  confirm_activate_collection_body:
    'By activating this Feature Collection you are confirming that you have validated its contents and functionality.',
  make_collection_obsolete: 'Make Obsolete',
  // Bug 479123 Issue 15: Header text updated per UX
  confirm_obsolete_collection_header:
    'Change this Collection\'s status to "Obsolete"?',
  confirm_obsolete_collection_body: (
    <>
      <p style={{ whiteSpace: 'break-spaces', marginBottom: 0 }}>
        {`Changing the status of this Feature Collection to "Obsolete" cannot be undone.

The Feature Collection cannot be:
`}
      </p>
      <ul>
        <li>Returned to "Active" status</li>
        <li>Added to a vehicle</li>
      </ul>
    </>
  ),
  collection_activated_success: 'Collection has been activated successfully.',
  collection_obsoleted_success: 'Collection has been marked as obsolete.',
  obsolete_collection_info:
    'This Feature Collections’ status is “Obsolete.” It cannot be added to a vehicle. You can either duplicate it or create a new collection.',
  changes_to_this_feature_collection_saved:
    'Changes to this Feature Collection have been saved.',
  collection_api_error: (
    <p>
      Something went wrong and CHEC was unable to save your changes. Please try
      again. To contact CHEC Support, please submit a{' '}
      <a
        href={DTNA_CASE_MANAGEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'white' }}
      >
        Salesforce case
      </a>
      .
    </p>
  ),
  activation_validation_obsolete_features:
    'To move this Feature Collection to "Active" some issues require your attention.',
  features_in_collection: 'Features in Collection',
  obsolete_features_warning:
    'This collection contains obsolete features that must be addressed before activation.',
  missing_title_warning: 'The collection title is required before activation.',
  duplicate_collection: 'Duplicate',
  confirm_duplicate_collection_header: 'Duplicate Collection?',
  confirm_duplicate_collection_body:
    'A new copy of this collection will be created in Design status. You can then modify and activate the new collection.',
  collection_duplicated_success: 'Collection has been duplicated successfully.',
  collection_duplicated_failure: 'Failed to duplicate collection.',
  collection_status_design: 'Design',
  collection_status_active: 'Active',
  collection_status_obsolete: 'Obsolete',
  status_filter_all: 'All Statuses',
  source_vehicle: 'Source Vehicle',
  setting_type: 'Setting Type',
  setting_type_tooltip: (
    <>
      <p>
        Select which source vehicle settings you want to apply to your fleet.
        You can apply:
      </p>
      <ul>
        <li>
          <em>"QuickFit Logic & PTO"</em> for Features and PTO settings
        </li>
        <li>
          <em>"QuickFit Logic"</em> for Features only
        </li>
        <li>
          <em>"PTO"</em> for PTO settings only
        </li>
      </ul>
    </>
  ),
  apply_settings: 'Apply Settings',
  label_text: 'label',
  header_text: 'header',
  twod_layout: '2D Layout',
  twod_layout_no_email: 'An email address is required to send the 2D layout.',
  twod_layout_archived: '2D Layout is not available for archived vehicles.',
  create_empty_collection: 'Create Empty Collection',
  create_from_vehicle: 'Create from Vehicle',
  select_source_vehicle: 'Select Source Vehicle',
  select_vehicle_base: 'Select Vehicle Base',
  vehicle_serial_number: 'Vehicle Serial Number',
  search_vehicle: 'Search Vehicle',
  create_collection_title: 'Create a Feature Collection',
  create_collection_description:
    'Create a new Feature Collection by selecting a source vehicle to copy features from, or create an empty collection with a vehicle base.',
  collection_created_successfully: 'Feature Collection created successfully.',
  collection_creation_failed: 'Failed to create Feature Collection.',
  vehicle_base: 'Vehicle Base',
  configure_from_a_vehicle: 'Configure From a Vehicle',
  configure_manually: 'Configure Manually',
  enter_a_serial_number: 'Enter a serial number...',
  enter_a_title: 'Enter a title...',
  enter_a_description: 'Enter a description...',
  model_year: 'Model Year',
  available_features: 'Available Features',
  import_available_features: 'Import available Features from this vehicle',
  create_feature_collection: 'Create Feature Collection',
  vehicle_not_found:
    'Vehicle not found. Please check the serial number and try again.',
  vehicle_not_found_for_collection:
    'This serial number cannot be used to create a Feature Collection. Please check the serial number and try again.',
  note_editing_collection: 'You are editing this Feature Collection',
  only_show_compatible_features: 'Only Show Compatible Features',
  only_show_compatible_collections: 'Only Show Compatible Collections',
  feature_collection_description: 'Feature Collection Description',
  no_features_added_yet: 'You have not added any Features yet.',
  feature_already_in_collection: 'This Feature is already in the collection.',
  feature_ecu_not_eligible:
    'Only Features on XMC 3 or XMC 4 can be added to a collection',
  feature_on_restricted_module:
    'Features on factory-controlled modules (ASAM, XMC 1, XMC 2) cannot be added',
  confirm_cancel_editing:
    'You have unsaved changes. Are you sure you want to cancel?',
  features_to_add: 'Features to Add',
  features_to_remove: 'Features to Remove',
  review_changes: 'Review Changes',
  collection_updated_successfully: 'Feature Collection successfully updated',
  collection_update_failed: 'Feature Collection update failed',
  no_changes_to_review: 'No changes to review',
  feature_status_not_valid:
    'Only Features with status \u201cActive\u201d may be added to a Feature Collection.',
  commit_to_feature_collection: 'Commit to Feature Collection',
  editing_feature_collection: 'Editing Feature Collection',
  add_remove_feature_to_collection: 'Add/Remove Feature to Collection',
  commit_changes_message: (collectionName) =>
    `You are about to commit changes to Feature Collection "${collectionName}"`,
  adding_following_features: 'Adding the following Features:',
  removing_following_features: 'Removing the following Features:',
  abandon_edit_collection:
    'You are about to abandon your progress. Are you sure you want to stop adding Features to this Feature Collection?',
  collection_org_restricted:
    'You do not have permission to edit this Feature Collection. Only users from the same organization as the collection creator, or DTNA, can make changes.',
  exit: 'Exit',
  updating_collection_details: 'Updating the following collection details:',
  commit_label_title: 'Title: ',
  commit_label_description: 'Description: ',
  feature_incompatible_ecu_tooltip:
    "This Feature cannot be added because it's incompatible with the ECU's software version.",
  unsaved_changes_count: (count) =>
    `${count} Unsaved Change${count !== 1 ? 's' : ''}`,
  update_feature_versions: 'Update Feature Versions',
  feature_version_updates: 'Feature Version Updates',
  feature_version_updates_explainer:
    'Updated versions of Features on this vehicle are available. Select which version of each Feature you would like to use.',
  version_on_vehicle: 'version on the vehicle',
  feature_version_available: 'Feature version available',
  version_selected_update: 'The updated version of this Feature will be used.',
  version_selected_keep: 'The current version of this Feature will be kept.',
  version_update_pending: 'An updated version is available.',
  version_cannot_be_added: 'This version cannot be applied at this time.',
  why_not: 'Why Not?',
  feature_status_label: 'Feature Status:',
  revised_from_obsolete_helper:
    'This version was revised. The previous version is in "Obsolete" status.',
  revised_to_active_helper:
    'This version was revised. The current version is in "Active" status.',
  revised_source_active_helper:
    'This version is in "Active" status. A revised version is available.',
  revised_to_test_helper: 'This is a revised version in "Test" status.',
  same_revision_helper:
    'This Feature was updated but not revised. The revision is the same.',
  no_replacement_available:
    'No other version of this Feature is available. It can only be manually removed from the vehicle.',
  too_many_resource: (resource, max, current, toRemove) =>
    `The updated version of this Feature uses too many ${resource}. The maximum is ${max}. With this Feature, the total would be ${current}. Remove ${toRemove} ${resource} to use this version.`,
  // WP-5: Add Collection to Vehicle wizard enhancements
  back_to_feature_collection: 'Back to Feature Collection',
  collection_incompatible_tooltip:
    'The settings of this collection are incompatible with your vehicle.',
  legacy_collection_warning:
    'This legacy collection was created without a Vehicle Type or QuickFit Sales Code. Some Features may not work as intended.',
  // Bug 516224: Legacy collection guard — disable editing and show persistent banner
  legacy_collection_view_warning:
    'This is a legacy collection. It was created without a QuickFit Sales Code or Minimum Diagnostic Variant.',
  legacy_collection_edit_disabled: 'Legacy collections cannot be edited.',
  legacy_collection_duplicate_disabled:
    'Legacy collections cannot be duplicated.',
  plus_series: 'Plus Series',
  x_series: 'X-Series',
  // PBI 144828: Per-row incompatibility warning on Feature Collection Details page
  feature_variant_exceeds_collection:
    "This feature's minimum diagnostic variant exceeds the collection's minimum compatible variant.",
  // Collection validation parity with vehicle flow
  collection_compatibility_check_failed:
    'Unable to check feature compatibility. Please try again.',
  collection_pin_conflict_check_failed:
    'Unable to check for pin conflicts. Please try again.',
  collection_dynamic_validation_failed:
    'Unable to validate dynamic content. Please try again.',
  collection_features_incompatible: (count) =>
    `${count} selected feature${
      count !== 1 ? 's are' : ' is'
    } not compatible with this collection and cannot be added.`,
  collection_dynamic_validation_dialog_content: ({
    collectionName,
    max,
    data,
  }) => (
    <>
      <p>
        CHEC added Logic Sets to <strong>{collectionName}</strong> because
        multiple Features control the same output. This exceeds the maximum{' '}
        <strong>{max}</strong> Logic Sets allowed on each ECU.
      </p>
      <ul>
        {data?.map((item) => (
          <li key={`${item.module}-${item.currentLogicCount}`}>
            There are <strong>{item.currentLogicCount}</strong> Logic Sets on{' '}
            <strong>{item.moduleDisplayName}</strong>
          </li>
        ))}
      </ul>
      <p>
        To commit your changes to <strong>{collectionName}</strong>, go back and
        remove:
      </p>
      <ul>
        {data?.map((item) => (
          <li key={item.module}>
            <strong>{item.currentLogicCount - item.maxLogicCount}</strong> Logic{' '}
            {item.currentLogicCount - item.maxLogicCount > 1 ? 'Sets' : 'Set'}{' '}
            from <strong>{item.moduleDisplayName}</strong>
          </li>
        ))}
      </ul>
      <p>This will require removing or editing Features.</p>
    </>
  ),
  // PBI 481284 – Fast Feature Management (notification messages used in sagas)
  fast_feature_added: 'Fast Features status updated.',
  fast_feature_removed: 'Fast Features status updated.',
  fast_feature_details_updated: 'Fast Feature Details Updated',
  fast_feature_status_error: 'The status of this Fast Feature was not updated.',
  fast_feature_save_error: 'Fast Feature Status Update Error',

  // Bug #509662: ECU resource limit modal — shown when the server returns a
  // Dynamic Logic Set overflow from POST .../features/validate/dynamic-content.
  // Static resource violations (Logic Sets, Timers, CAN Inputs, Switch Indicators)
  // are surfaced exclusively via inline Alert banners; the modal is reserved for
  // server-side dynamic-content overflow only.
  resource_limit_modal_title: (type) => `There are too many ${type}`,

  resource_limit_modal_content: ({ type, data }) => (
    <>
      <p>
        The collection currently exceeds the maximum{' '}
        <strong>{data[0]?.max}</strong> {type} allowed per ECU.
      </p>
      <ul>
        {data.map((item) => (
          <li key={`${item.moduleName}-current`}>
            There are <strong>{item.count}</strong> {type} on{' '}
            <strong>{item.moduleDisplayName}</strong>
          </li>
        ))}
      </ul>
      <p>
        To commit your changes to this Feature Collection, go back and remove:
      </p>
      <ul>
        {data.map((item) => (
          <li key={`${item.moduleName}-remove`}>
            <strong>{item.count - item.max}</strong>{' '}
            {item.count - item.max === 1 ? type.replace(/s$/, '') : type} from{' '}
            <strong>{item.moduleDisplayName}</strong>
          </li>
        ))}
      </ul>
      <p>This will require removing or editing Features.</p>
    </>
  ),

  // Vehicle Snapshot Modal
  snapshot_exit_view: 'Exit Snapshot View',
  snapshot_viewing_vehicle: 'Viewing snapshots for vehicle',
  snapshot_no_feature_data: 'No Features on these modules',
  snapshot_quickfit_modules: 'QuickFit Programmable Modules',
  snapshot_school_bus_modules: 'School Bus Programmable Modules',
  snapshot_pto_no_data: 'No PTO on this vehicle',
  snapshot_pto_domain_label: 'PTO Domain',
  snapshot_pto_no_settings:
    'This snapshot does not contain any settings for this Domain.',
  snapshot_pneumatics_no_data: 'No ECPs on this vehicle',
  snapshot_sng_no_data:
    'No Switch & Gauge data was recorded for this snapshot.',
  snapshot_factory_data_unavailable:
    'Factory data is not available for this vehicle.',
  // Snapshot saga notifications
  snapshot_creating: 'Your vehicle snapshot is being created.',
  snapshot_created: 'Your vehicle snapshot is ready to view.',
  snapshot_create_limit:
    'Maximum snapshot limit reached for this vehicle. Remove a snapshot to save a new one.',
  snapshot_save_error:
    'Something went wrong and CHEC was unable to save your changes. Please try again. To contact CHEC Support, please submit a case using',
  snapshot_deleted: 'Snapshot deleted.',
  snapshot_delete_own_only: 'You can only delete your own snapshots.',
  snapshot_removal_confirmation:
    'Are you sure you want to remove this snapshot?',
  // ── API error modal copy ─────────────────────────────────────────────────
  // Used by mutationErrorHandler.js, defaultErrorHandler.js, and ModalErrorContent.
  // Centralised here so a copy change only requires one edit.
  api_error_body_line1:
    'Your request could not be completed because of an unexpected error. Changes that were not previously saved may have been lost.',
  api_error_body_line2: 'Please refresh the page to continue using CHEC.',

  // Switch Output Mapping
  fast_feature_mapping: 'Fast Feature Mapping',
  switch_output_title: 'Fast Feature Switch to Output Mapping',
  switch_output_info_bar: (serialNumber) =>
    `You are viewing Fast Feature output assignments for ${
      serialNumber || ''
    }.`,
  switch_output_details: 'Details',
  switch_output_switch: 'Switch',
  switch_output_connector: 'Connector',
  switch_output_solenoid: 'Solenoid',
  switch_output_part_number: 'Part Number',
  switch_output_cap_pn: 'Cap P/N',
  switch_output_position: 'Position',
  switch_output_interface: 'Interface',
  switch_output_source: 'Source',
  switch_output_pin_type: 'Pin Type',
  switch_output_current: 'Current',
  switch_output_ecp_number: 'ECP Number',
  switch_output_location: 'Location',
  switch_output_cable_color: 'Cable Color',
  switch_output_error:
    'Unable to load switch mapping data. Please try again later.',
  switch_output_no_mappings:
    'No switch to output mappings found for this vehicle.',
  print: 'Print',
  dash_panel_navigation: 'Dash Panel Navigation',

  // Feature origin classification (PBI 490151)
  origin_specced_banner:
    'The As-Built Features on this vehicle were assigned as part of the original vehicle order.',
  origin_automated_banner:
    'The As-Built Features on this vehicle were assigned automatically during the vehicle build process.',
}
